import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  AlertDialogPortal,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PaymentType } from "@/lib/validations/schema";
import { ColumnDef } from "@tanstack/react-table";
import { AxiosRequestConfig } from "axios";
import { order_status_options } from "common/filters";
import { Button, Img, Spinner } from "components";
import { DataTableColumnHeader } from "components/Table/data-table-column-header";
import { DataTable } from "components/Table/DataTable";
import UploadDocuments from "models/OrderDetails/CaptureDocuments";
import AddDeclaration from "models/OrderDetails/CapturePayment";
import SettlementRate from "models/OrderDetails/SettlementRate";
import { convertFileToBase64 } from "pages/CreateRemit/payment";
import { formatUnixTimestamp } from "pages/Opportunities/utils/featureRule";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { useNavigate, useParams } from "react-router-dom";
import {
  AddOrderNotesAPI,
  PaymentStatusAPI,
  POSTAddNotesOrderRequestType,
  POSTeditPaymentStatusRequestType,
} from "service/apis/CreateOrderapi";
import {
  CapturePaymentRequestType,
  CaptureUtrRequestType,
  GetPartnerDetailsRequestType,
  PutOrderStatusRequestType,
  capturePayment,
  capturePaymentL2,
  captureUtr,
  getPartnerDetails,
  putOrderStatus,
} from "service/apis/Orderdetails";
import { Toaster, toast } from "sonner";
import { formatCurrency } from "utils";
import OrderDocuments from "./documents";
import PaymentReview from "./new-payment";
import MilestoneTracker, { MilestoneItem } from "./mile-stone";
import { useAppDispatch } from "redux/hooks";
import {
  setAdditionalDocBase64,
  setAdditionalDocs,
  setAllDocs,
  setCreatedBy,
  setDocs,
  setIsDealflowCheck,
  setKycDocBase64,
  setKycDocs,
  setPurposeId,
  setServicePartnerID,
  setType,
  setDealID as setDealId,
  setOrderId,
} from "redux/features/CreateOrder";
import ChallanDialog from "./challan";
import { TooltipGlobal } from "components/GlobalTooltip";
import { checkLevel } from "common/rules";
import { LEVEL_2 } from "common/constants";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import {
  setAmountSent,
  setCurrency,
  setPurpose,
  setOrderId as setRefundOrderId,
  setPurposeId as setRefundPurposeId,
  setSenderName,
  setServicePartnerId,
  setCreatedBy as setRefundCreatedBy,
  setDealId as setRefundDealId,
  setRefundTTRate,
  setRefundForeignBankRate,
  setServicePartnerBankId,
  setDocuments,
  setPartnerOrderId,
  setExtraDocument,
} from "redux/features/RefundOrder";
import { calculateProfit } from "pages/RefundOrder/steps/step2";

// const bank_doc_ids = [51, 52, 53, 29];
const bank_doc_ids = [50, 51, 52, 53, 29, 45, 46, 47];

type OrderdetailsType = {
  id: string;
  status: string;
  payment_status: string;
  created_at: string;
  country: string;
  type: string;
  note: string;
  note_last_edited: number;
  _order_customers: {
    full_name: string;
    email: string;
    phone: string;
    pan_no: string;
    aadhaar_no: string;
    pan_soft_copy: {
      url: string;
    };
    aadhaar_soft_copy_front: {
      url: string;
    };
  };
  supporting_documents: [];
  _order_channels: {
    id: string;
    name: string;
    phone: string;
    email: string;
    address: string;
  };
  _beneficiary: {
    account_number: string;
    bank_addr: string;
    bank_country: string;
    bank_name: string;
    correspondant_bank_name: string;
    correspondant_bank_no: string;
    iban_no: string;
    id: number;
    name: string;
    swift_code: string;
  };
  partner_detail: {
    city: string;
    id: number;
    name: string;
    state: string;
    type: string;
  };
  amount: number;
  currency: string;
  gst: number;
  tcs: number;
  tt_charges_inclgst: number;
  foreign_bank_rates_inclgst: number;
  opportunity_id: number;
  payable_amount: number;
  l1_commission_rates: number;
  l2_commission_rates: number;
  l3_commission_rates: number;
  l1_channel: number;
  l2_channel: number;
  l3_channel: number;
  service_partner_rates: number;
  eforex_rates: number;
  _payments_of_order: {
    id: string;
    acknowledgement_no: string;
    amount: string;
    receipt?: {
      url: string;
    };
  }[];
  _order_service_partner: {
    id: string;
    display_name: string;
    email: string;
    legal_addr_city: string;
    legal_addr_state: string;
  };
  _order_created_by: {
    id: number;
    fname: string;
    phone_number: string;
    email: string;
  };
  order_mileston: [];
  swift_document: {
    url: string;
  };
  invoice_document: {
    url: string;
  };
  _purpose: {
    id: string;
    name: string;
  };
};

type ChannelDetails = {
  id: number;
  Type: string;
  Channel: string;
  category: string;
  source: string;
};

const NewOrderDetailsPage: React.FC = () => {
  const {
    register,
    getValues,
    setValue,
    reset,
    handleSubmit,
    watch,
    clearErrors,
    formState: { errors },
  } = useForm();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [paidAmount, setPaidAmount] = useState<number>();
  const [challanState, setChallanState] = useState({});
  const [verifyDocs, setVerifyDocs] = useState(false);
  const [isopen, setIsopen] = useState(false);
  const [rowSelected, setRowSelected] = useState<any>();
  const { id } = useParams();
  const param = useParams();
  const dispatch = useAppDispatch();
  const [orderdetails, setOrderDetails] = useState<OrderdetailsType>();
  const [payAmountVal, setPayAmountVal] = useState<number>(0);
  const [servicePartnerBanks, setServicePartnerBanks] = useState<any[]>([]);
  const [createdate, setCreateDate] = useState<any>();
  const [showcapturepayment, setShowCapturePayment] = useState(false);
  const [showUploadDocumentType, setShowUploadDocumentType] = useState("");
  const [showSettlementRate, setShowSettlementRate] = useState(false);
  const [showimg, setShowimg] = useState(false);
  const [imgsrc, setImgsrc] = useState("");
  const [orderstatus, setOrderStatus] = useState("");
  const [loading, setLoading] = useState(false);
  const [remainingAmount, setRemainingAmount] = useState<number>();
  const [activeTab, setTab] = useState<string>("overview");
  const [paymentData, setPaymentData] = useState<PaymentType[]>([]);
  const [UTRData, setUTRData] = useState<any[]>([]);
  const [shouldRefetch, setShouldRefetch] = useState(false);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [invoiceFile, setInvoiceFile] = useState<File | null>(null);
  const [paymnetFile, setPaymentFile] = useState<File | null>(null);
  const [dealID, setDealID] = useState<number>();
  const [studentName, setStudentName] = useState<string>("");
  const [channelDetails, setChannelDetails] = useState<ChannelDetails>();
  const [margin, setMargin] = useState({
    l1: "",
    l2: "",
    l3: "",
  });
  const [profits, setProfits] = useState({
    l1_profit: '',
    l2_profit: '',
    l3_profit: '',
  })
  const [isEditing, setIsEditing] = useState(false);
  const [note, setNote] = useState<string>("");
  const [tempNote, setTempNote] = useState<string>(note);
  const [isTCSEditing, setIsTCSEditing] = useState(false);
  const [tcsValue, setTcsValue] = useState<string>(
    orderdetails?.tcs?.toFixed(2) || "",
  );
  const [isChecked, setIsChecked] = useState<boolean>(false);

  const openDetailNote = () => {
    setIsEditing(true);
  };

  const handleSave = async (order_id: number, note: string) => {
    setNote(tempNote);
    setIsEditing(false);

    setLoading(true);
    const auth = localStorage.getItem("authToken");
    if (!auth) return;
    const authToken = JSON.parse(auth);
    const payload: AxiosRequestConfig<POSTAddNotesOrderRequestType> = {
      headers: { Authorization: `Bearer ${authToken}` },
      data: {
        order_id,
        note,
      },
    };
    try {
      const response = await AddOrderNotesAPI(payload);
      if (response?.status === 200) {
        OrderDetails();
        console.log("API resp ====?>>>>", response?.data);
      }
    } catch (error) {
      toast.error("Failed to update partner details");
    } finally {
      setLoading(false);
    }
  };

  const handleTCSCancel = () => {
    setTcsValue("0.00");
    setIsTCSEditing(false);
  };

  // for TCS
  const handleTCSSave = async (
    order_id: number,
    note: string,
    tcs_amount: number,
  ) => {
    setLoading(true);
    const auth = localStorage.getItem("authToken");
    if (!auth) return;
    const authToken = JSON.parse(auth);
    const payload: AxiosRequestConfig<POSTAddNotesOrderRequestType> = {
      headers: { Authorization: `Bearer ${authToken}` },
      data: {
        order_id,
        note,
        tcs_amount,
      },
    };
    try {
      const response = await AddOrderNotesAPI(payload);
      if (response?.status === 200) {
        OrderDetails();
        setIsTCSEditing(false);
        setTcsValue("0.00");
        setIsChecked(false);
        toast.success("TCS updated successfully");
      }
    } catch (error) {
      toast.error("Failed to update partner details");
    } finally {
      setLoading(false);
    }
  };

  const handleDocReview = async (isReview: boolean) => {
    setLoading(true);
    const auth = localStorage.getItem("authToken");
    if (!auth) return;
    const authToken = JSON.parse(auth);
    const payload: AxiosRequestConfig<POSTAddNotesOrderRequestType> = {
      headers: { Authorization: `Bearer ${authToken}` },
      data: {
        order_id: Number(id),
        doc_status: isReview ? "Approved" : "Review",
      },
    };
    try {
      const response = await AddOrderNotesAPI(payload);
      if (response?.status === 200) {
        OrderDetails();
        setVerifyDocs(false);
      }
    } catch (error) {
      toast.error("Failed to update partner details");
    } finally {
      setLoading(false);
    }
  };

  const handlePaymentFileChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    if (event.target.files?.[0]) {
      setPaymentFile(event.target.files[0]);
    }
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files?.[0]) {
      setSelectedFile(event.target.files[0]);
    }
  };

  const navigate = useNavigate();

  useEffect(() => {
    OrderDetails();
  }, [id, shouldRefetch]);

  useEffect(() => {
    if (orderdetails) {
      const date = new Date(orderdetails?.created_at);
      setCreateDate(date.toUTCString().substring(0, 16));
    }

    const amount = orderdetails?._payments_of_order.reduce(
      (accumulator, currentValue) => accumulator + Number(currentValue.amount),
      0,
    );
    setRemainingAmount(Number(orderdetails?.payable_amount) - Number(amount));
  }, [orderdetails]);

  const level = localStorage.getItem("level");
  const channel_id = localStorage.getItem("channel_id");
  const orderChildLevel =
    orderdetails?.l2_channel == 0
      ? "1"
      : orderdetails?.l3_channel == 0
        ? "2"
        : "3";

  const OrderDetails = (): void | null => {
    const auth: string | null = localStorage.getItem("authToken");
    if (auth === null) return null;
    const authToken = JSON.parse(auth);
    const payload: AxiosRequestConfig<GetPartnerDetailsRequestType> = {
      data: {
        order_id: id,
      },
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    };
    getPartnerDetails(payload)
      .then((res: any) => {
        console.log(res.data);
        setDealID(res?.data?.dealID);
        setPaidAmount(res?.data?.amount_paid);
        if (res.data?.result_1?.refund_order_id) {
          setChannelDetails(
            res?.data?.channel_for_refund?.[0]?._channel_of_interaction?.[0],
          );
        } else {
          setChannelDetails(res?.data?.channel?.[0]);
        }
        setStudentName(res?.data?.student_name);
        setPayAmountVal(res?.data?.amount_paid);
        setOrderDetails(res.data?.result_1);
        setChallanState({
          status: res?.data?.result_1?.challan_generated,
          challan_url: res?.data?.result_1?.challan_url,
          timestamp: res?.data?.result_1?.challan_timestamp,
          challan_generated_by_staff:
            res?.data?.result_1?.challan_generated_by_staff,
          challan_generated_by_AD: res?.data?.result_1?.challan_generated_by_AD,
        });
        setServicePartnerBanks(res?.data?.bank_list);
        setNote(res.data?.result_1?.note);
        setMargin({
          l1: res.data?.result_1?.l1_commission_rates.toString(),
          l2: res.data?.result_1?.l2_commission_rates.toString(),
          l3: res.data?.result_1?.l3_commission_rates.toString(),
        });
        setProfits({
          l1_profit: res.data?.result_1?.l1_profit?.toString(),
          l2_profit: res.data?.result_1?.l2_profit?.toString(),
          l3_profit: res.data?.result_1?.l3_profit?.toString(),
        })
        setPaymentData(
          res.data?.result_1?._payments_of_order.map(
            (payment: any, index: number) => ({
              id: index + 1,
              acknowledgement: payment.acknowledgement_no,
              createdBy: "N/A",
              creationDate: new Date().toDateString(),
              amount: parseInt(payment.amount),
              receipt: payment.receipt,
              supporting_doc: payment.supporting_doc,
              paymentMode: "Offline",
              status: payment?.status_by_AD2,
              notes: payment?.notes,
              created_by: res?.data?.paymets_staff?.find((val) => {
                return val.id === payment.id;
              })?._staff?.fname,
            }),
          ) || [],
        );
        setUTRData(
          res.data?.result_1?.utr_capture?.map((utr: any) => {
            return {
              utr_no: utr?.utr_number,
              url: utr?.utr_invoice?.url,
              mediaType: utr?.utr_invoice?.type,
              createdAt: formatUnixTimestamp(utr?.created_at).split("|")[0],
              createdBy: utr?._staff?.fname,
            };
          }),
        );
        if (res.data.result_1.status) {
          setOrderStatus(res.data?.result_1.status);
        }
      })
      .catch((err) => console.log(err));
  };

  const generateChallan = async () => {};

  const handleonorderstatuschange = (e: string): void => {
    const auth: string | null = localStorage.getItem("authToken");
    if (auth === null) return;
    const authToken = JSON.parse(auth);

    const payload: AxiosRequestConfig<PutOrderStatusRequestType> = {
      data: {
        status: e,
        order_id: id,
      },
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    };
    setLoading(true);
    putOrderStatus(payload)
      .then((res: any) => {
        setLoading(false);
        setOrderStatus(res.data.status);
        OrderDetails();
        toast.success("Order Status Updated Successfully");
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err?.response?.data?.message);
      });
  };

  const downloadFilefromUrl = async (pdf_url: string, name: string) => {
    try {
      const response = await fetch(pdf_url);
      const blob = await response.blob();
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = name;

      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
    } catch (error) {}
  };

  const status = orderdetails?.payment_status;
  let paymentborderColor;
  switch (status) {
    case "pending":
      paymentborderColor = "bg-[#FFA500]"; // Gray
      break;
    case "partially recieved":
      paymentborderColor = "bg-[#0000FF]"; // Light Green
      break;
    case "recieved":
      paymentborderColor = "bg-[#008000]"; // Green
      break;
    default:
  }

  let statusbgcolor = orderstatus;
  switch (statusbgcolor) {
    case "pending":
      statusbgcolor = "bg-[#808080]"; // Gray
      break;
    case "processing":
      statusbgcolor = "bg-[#32CD32]"; // Light Green
      break;
    case "fulfilled":
      statusbgcolor = "bg-colors1"; // Green
      break;
    case "pre processing":
      statusbgcolor = "bg-[#888888]";
      break;
    case "cancelled":
      statusbgcolor = "bg-[#FF0000]";
      break;
    default:
  }

  let tabsdata = [
    {
      id: 1,
      label: "Overview",
      value: "overview",
      content: "Make changes to your account here.",
    },
    {
      id: 2,
      label: "Amount & Charges",
      value: "amount-charges",
      content: "Change your password here.",
    },
    {
      id: 3,
      label: "Documentations",
      value: "documents",
      content: "Change your password here.",
    },
    {
      id: 4,
      label: "Payments",
      value: "payments",
      content: "Change your password here.",
    },
    {
      id: 5,
      label: "Other Details",
      value: "other-details",
      content: "Change your password here.",
    },
  ];
  const columns: ColumnDef<PaymentType>[] = [
    {
      accessorKey: "id",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Ref ID" />
      ),
    },
    {
      accessorKey: "acknowledgement",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Acknowledgement" />
      ),
      enableSorting: false,
    },
    {
      accessorKey: "createdBy",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Created By" />
      ),
      cell: ({ row }) => {
        return (
          <p className="text-[#333333] font-medium text-sm leading-[21px]">
            {row.original.created_by || "N/A"}
          </p>
        );
      },
      enableSorting: false,
    },
    {
      accessorKey: "creationDate",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Date Created" />
      ),
      enableSorting: false,
    },
    {
      accessorKey: "amount",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Amount" />
      ),
      enableSorting: false,
    },
    {
      accessorKey: "Receipt",
      cell: ({ row }) => {
        const receiptUrl = row.original.receipt;
        const supportingDocUrl = row.original.supporting_doc;
        const handleApprove = async (status_AD2: string, notes: string) => {
          setLoading(true);
          const auth = localStorage.getItem("authToken");
          if (!auth) return;
          const authToken = JSON.parse(auth);
          const payload: AxiosRequestConfig<POSTeditPaymentStatusRequestType> =
            {
              headers: { Authorization: `Bearer ${authToken}` },
              data: {
                order_id: Number(id),
                ack_no: row.original.acknowledgement,
                status_AD2,
                notes,
              },
            };
          try {
            const response = await PaymentStatusAPI(payload);
            if (response?.status === 200) {
              setLoading(false);
              if (status_AD2 === "rejected") {
                toast.success("Payment rejected!!");
              } else toast.success("Payment approved successfully");
            }
          } catch (error) {
            toast.error("Failed to update partner details");
            setLoading(false);
          }
        };
        if (row?.original?.status === "accept") {
          return (
            <div className="flex items-center gap-1.5">
              <p className="max-w-[200px] py-1 bg-[#E1FFE2] px-2 rounded-md text-[#00A82D] whitespace-normal break-words">
                Approved
              </p>
              <button
                onClick={() => window.open(row.original.receipt.url, "_blank")}
                className=""
              >
                <svg
                  width="18"
                  height="12"
                  viewBox="0 0 18 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16.3221 5.28375C16.5501 5.60325 16.6641 5.76375 16.6641 6C16.6641 6.237 16.5501 6.39675 16.3221 6.71625C15.2976 8.15325 12.6808 11.25 9.16406 11.25C5.64656 11.25 3.03056 8.1525 2.00606 6.71625C1.77806 6.39675 1.66406 6.23625 1.66406 6C1.66406 5.763 1.77806 5.60325 2.00606 5.28375C3.03056 3.84675 5.64731 0.75 9.16406 0.75C12.6816 0.75 15.2976 3.8475 16.3221 5.28375Z"
                    stroke="#165FE3"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M11.4141 6C11.4141 5.40326 11.177 4.83097 10.7551 4.40901C10.3331 3.98705 9.7608 3.75 9.16406 3.75C8.56733 3.75 7.99503 3.98705 7.57307 4.40901C7.15112 4.83097 6.91406 5.40326 6.91406 6C6.91406 6.59674 7.15112 7.16903 7.57307 7.59099C7.99503 8.01295 8.56733 8.25 9.16406 8.25C9.7608 8.25 10.3331 8.01295 10.7551 7.59099C11.177 7.16903 11.4141 6.59674 11.4141 6Z"
                    stroke="#165FE3"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
            </div>
          );
        }
        if (row?.original?.status === "reject") {
          return (
            <div className="flex items-center gap-1.5">
              <p className="max-w-[200px] bg-red-200 px-2 py-1 flex items-center gap-x-2 rounded-md text-red-500 whitespace-normal break-words">
                Rejected
                <TooltipGlobal
                  content={row?.original?.notes}
                  triggerClassName=""
                  contentClassName="bg-[#000] border-none text-white-A700"
                >
                  <button>
                    <svg
                      width="13"
                      height="12"
                      viewBox="0 0 13 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.5 0.09375C5.33186 0.09375 4.18994 0.440146 3.21867 1.08913C2.24739 1.73812 1.49037 2.66055 1.04334 3.73978C0.596309 4.819 0.479346 6.00655 0.70724 7.15225C0.935134 8.29795 1.49765 9.35035 2.32365 10.1763C3.14966 11.0024 4.20205 11.5649 5.34775 11.7928C6.49345 12.0207 7.681 11.9037 8.76023 11.4567C9.83945 11.0096 10.7619 10.2526 11.4109 9.28134C12.0599 8.31006 12.4063 7.16815 12.4063 6C12.4046 4.43407 11.7818 2.93276 10.6745 1.82548C9.56725 0.718198 8.06593 0.0954036 6.5 0.09375ZM6.27284 2.81971C6.40762 2.81971 6.53938 2.85968 6.65145 2.93456C6.76353 3.00945 6.85087 3.11588 6.90245 3.24041C6.95403 3.36493 6.96753 3.50196 6.94123 3.63415C6.91494 3.76635 6.85003 3.88778 6.75472 3.98309C6.65942 4.0784 6.53799 4.1433 6.40579 4.1696C6.27359 4.19589 6.13657 4.1824 6.01204 4.13082C5.88752 4.07924 5.78108 3.99189 5.7062 3.87982C5.63132 3.76775 5.59135 3.63599 5.59135 3.5012C5.59135 3.32046 5.66315 3.14712 5.79095 3.01932C5.91876 2.89151 6.0921 2.81971 6.27284 2.81971ZM6.95433 9.18029C6.71334 9.18029 6.48222 9.08456 6.31181 8.91415C6.14141 8.74374 6.04568 8.51262 6.04568 8.27164V6C5.92518 6 5.80962 5.95213 5.72442 5.86693C5.63921 5.78173 5.59135 5.66617 5.59135 5.54567C5.59135 5.42518 5.63921 5.30962 5.72442 5.22442C5.80962 5.13921 5.92518 5.09135 6.04568 5.09135C6.28667 5.09135 6.51779 5.18708 6.68819 5.35748C6.8586 5.52789 6.95433 5.75901 6.95433 6V8.27164C7.07482 8.27164 7.19038 8.3195 7.27559 8.4047C7.36079 8.48991 7.40866 8.60547 7.40866 8.72596C7.40866 8.84646 7.36079 8.96202 7.27559 9.04722C7.19038 9.13242 7.07482 9.18029 6.95433 9.18029Z"
                        fill="#FF0000"
                      />
                    </svg>
                  </button>
                </TooltipGlobal>
              </p>
            </div>
          );
        }
        return (
          <div className="flex flex-col gap-2">
            {row?.original?.paymentMode === "Offline" ? (
              <PaymentReview
                paymentProofUrl={receiptUrl}
                refetchOrder={OrderDetails}
                onApprove={handleApprove}
                supportingDocUrl={supportingDocUrl}
                amount={row?.original?.amount}
              >
                {checkLevel(LEVEL_2) ? (
                  <button
                    style={{
                      display: "flex",
                      padding: "10px 20px",
                      backgroundColor: "inherit",
                      color: "#333333",
                      textDecoration: "none",
                      borderRadius: "5px",
                      border: "1px solid #333333",
                      fontWeight: "bold",
                      textAlign: "center",
                      cursor: "pointer",
                      transition: "background-color 0.3s ease",
                    }}
                    disabled={true}
                  >
                    Approval Pending
                  </button>
                ) : (
                  <button
                    style={{
                      display: "flex",
                      padding: "10px 20px",
                      backgroundColor: "inherit",
                      color: "#333333",
                      textDecoration: "none",
                      borderRadius: "5px",
                      border: "1px solid #333333",
                      fontWeight: "bold",
                      textAlign: "center",
                      cursor: "pointer",
                      transition: "background-color 0.3s ease",
                    }}
                    onClick={() => {
                      setIsopen(true);
                    }}
                  >
                    Review
                  </button>
                )}
              </PaymentReview>
            ) : (
              <>
                <p
                  style={{
                    backgroundColor: order_status_options.find(
                      (status) => orderdetails?.status === status.value,
                    )?.bgColor,
                    color: order_status_options.find(
                      (status) => orderdetails?.status === status.value,
                    )?.textColor,
                  }}
                  className="py-[4px] text-sm leading-4 capitalize font-medium  px-2 text-center rounded-md"
                >
                  {orderdetails?.payment_status}
                </p>
              </>
            )}
          </div>
        );
      },
    },
  ];

  const UTRColumn: ColumnDef<PaymentType>[] = [
    {
      accessorKey: "id",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="UTR number" />
      ),
      cell: ({ row }) => {
        return (
          <p className="text-[#333333] font-medium text-sm leading-[21px]">
            {row?.original?.utr_no || "N/A"}
          </p>
        );
      },
    },
    {
      accessorKey: "createdAt",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Date created" />
      ),
      cell: ({ row }) => {
        return (
          <div className="flex flex-col gap-1">
            <p className="text-[#333333] font-medium text-sm leading-[21px]">
              {row?.original?.createdAt || "N/A"}
            </p>
            <p className="text-[#666666] font-normal text-sm leading-[21px]">
              {row?.original?.createdBy || "N/A"}
            </p>
          </div>
        );
      },
      enableSorting: false,
    },
    {
      accessorKey: "invoice",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Invoice" />
      ),
      cell: ({ row }) => {
        return (
          <p className="text-[#333333] font-medium text-sm leading-[21px]">
            {row?.original?.url ? (
              <div className="flex items-center gap-6">
                <button
                  onClick={() => {
                    window.open(row?.original?.url, "_blank");
                  }}
                  className=""
                >
                  <svg
                    width="23"
                    height="16"
                    viewBox="0 0 23 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M21.044 7.045C21.348 7.471 21.5 7.685 21.5 8C21.5 8.316 21.348 8.529 21.044 8.955C19.678 10.871 16.189 15 11.5 15C6.81 15 3.322 10.87 1.956 8.955C1.652 8.529 1.5 8.315 1.5 8C1.5 7.684 1.652 7.471 1.956 7.045C3.322 5.129 6.811 1 11.5 1C16.19 1 19.678 5.13 21.044 7.045Z"
                      stroke="#165FE3"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M14.5 8C14.5 7.20435 14.1839 6.44129 13.6213 5.87868C13.0587 5.31607 12.2956 5 11.5 5C10.7044 5 9.94129 5.31607 9.37868 5.87868C8.81607 6.44129 8.5 7.20435 8.5 8C8.5 8.79565 8.81607 9.55871 9.37868 10.1213C9.94129 10.6839 10.7044 11 11.5 11C12.2956 11 13.0587 10.6839 13.6213 10.1213C14.1839 9.55871 14.5 8.79565 14.5 8Z"
                      stroke="#165FE3"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </button>
                <button
                  onClick={() => {
                    downloadFilefromUrl(
                      row?.original?.url,
                      row?.original?.utr_no + "_invoice",
                    );
                  }}
                  className=""
                >
                  <svg
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.5 11.575C8.36667 11.575 8.24167 11.5543 8.125 11.513C8.00833 11.4717 7.9 11.4007 7.8 11.3L4.2 7.7C4 7.5 3.904 7.26667 3.912 7C3.92 6.73334 4.016 6.5 4.2 6.3C4.4 6.1 4.63767 5.996 4.913 5.988C5.18833 5.98 5.42567 6.07567 5.625 6.275L7.5 8.15V1C7.5 0.71667 7.596 0.479337 7.788 0.288004C7.98 0.0966702 8.21733 0.000670115 8.5 3.44827e-06C8.78267 -0.000663218 9.02033 0.0953369 9.213 0.288004C9.40567 0.48067 9.50133 0.718003 9.5 1V8.15L11.375 6.275C11.575 6.075 11.8127 5.979 12.088 5.987C12.3633 5.995 12.6007 6.09934 12.8 6.3C12.9833 6.5 13.0793 6.73334 13.088 7C13.0967 7.26667 13.0007 7.5 12.8 7.7L9.2 11.3C9.1 11.4 8.99167 11.471 8.875 11.513C8.75833 11.555 8.63333 11.5757 8.5 11.575ZM2.5 16C1.95 16 1.47933 15.8043 1.088 15.413C0.696666 15.0217 0.500667 14.5507 0.5 14V12C0.5 11.7167 0.596 11.4793 0.788 11.288C0.98 11.0967 1.21733 11.0007 1.5 11C1.78267 10.9993 2.02033 11.0953 2.213 11.288C2.40567 11.4807 2.50133 11.718 2.5 12V14H14.5V12C14.5 11.7167 14.596 11.4793 14.788 11.288C14.98 11.0967 15.2173 11.0007 15.5 11C15.7827 10.9993 16.0203 11.0953 16.213 11.288C16.4057 11.4807 16.5013 11.718 16.5 12V14C16.5 14.55 16.3043 15.021 15.913 15.413C15.5217 15.805 15.0507 16.0007 14.5 16H2.5Z"
                      fill="#165FE3"
                    />
                  </svg>
                </button>
              </div>
            ) : (
              "No Invoice"
            )}
          </p>
        );
      },
      enableSorting: false,
    },
  ];
  const labelStyle = "font-medium text-[#666666] text-sm leading-[21px]";
  const valueStyle = "font-medium text-[#333333] text-sm leading-[21px]";

  const onTabChange = (value: string) => {
    setTab(value);
  };

  const onSaveClick = async (data: any, type = "") => {
    const formData = {
      ...data,
      payment_proof: data.payment_proof_base64,
      supporting_document: data.supporting_document_base64 || null,
    };

    try {
      if (type === "approve") {
        const paymentResult = await handleCapturePayment(formData); // Ensure this completes first
        const approvalResult = await handleApprove(
          "accept",
          data.notes,
          formData.acknowledgement_no,
        ); // Run only if payment succeeds

        await Promise.all([paymentResult, approvalResult]); // Ensure both resolve successfully

        setPaymentFile(null);
        setSelectedFile(null);
        reset(); // Reset the form
        OrderDetails();
      } else {
        await handleCapturePayment(formData);
        setPaymentFile(null);
        setSelectedFile(null);
        reset(); // Reset the form
        OrderDetails();
      }
    } catch (error) {
      console.error("Error in processing:", error);
    }
  };

  const handleUTR = async (data: any) => {
    const formData = {
      order_id: id,
      utr_number: data.utr_no,
      utr_file: data.invoice_base64 || "",
    };
    setLoading(true);
    const auth = localStorage.getItem("authToken");
    if (!auth) return;
    const authToken = JSON.parse(auth);
    const payload: AxiosRequestConfig<CaptureUtrRequestType> = {
      headers: { Authorization: `Bearer ${authToken}` },
      data: formData,
    };
    try {
      const response = await captureUtr(payload);
      if (response?.status === 200) {
        toast.success("UTR added successfully");
        setLoading(false);
        setDialogOpen(false);
        reset();
        setInvoiceFile(null);
        OrderDetails();
      }
    } catch (error) {
      toast.error("Failed to update UTR");
      setLoading(false);
    }
  };

  const handlePaymentProofChange = async (
    e: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const file = e?.target?.files ? e?.target?.files[0] : null;
    if (file) {
      setPaymentFile(file);
      const base64 = await convertFileToBase64(file);
      setValue("payment_proof_base64", base64);
    }
  };

  const handleSupportingFileChange = async (
    e: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const file = e?.target?.files ? e?.target?.files[0] : null;
    if (file) {
      setSelectedFile(file);
      const base64 = await convertFileToBase64(file);
      setValue("supporting_document_base64", base64);
    }
  };

  const handleInvoiceFileChange = async (
    e: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const file = e?.target?.files ? e?.target?.files[0] : null;
    if (file) {
      setInvoiceFile(file);
      const base64 = await convertFileToBase64(file);
      setValue("invoice_base64", base64);
    }
  };

  const handleCapturePayment = async (formData: any) => {
    setLoading(true);
    const auth: string | null = localStorage.getItem("authToken");
    if (auth === null) return;
    const authToken = JSON.parse(auth);
    const payload = {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
      data: {
        acknowledgement_no: formData.acknowledgement_no,
        amount: formData.amount,
        receipt: formData.payment_proof,
        supporting_doc: formData.supporting_document,
        order_id: id,
      } as CapturePaymentRequestType,
    };
    try {
      if (checkLevel(LEVEL_2)) {
        await capturePaymentL2(payload);
      } else {
        await capturePayment(payload);
      }
      toast.success("Payment Captured Successfully");
      setDialogOpen(false);
      setLoading(false);
    } catch (error: any) {
      toast.error(error?.response?.data?.message);
      setLoading(false);
    }
  };

  const handleSwiftDocument = () => {
    if (orderdetails?.swift_document?.url) {
      downloadFilefromUrl(orderdetails?.swift_document.url, "swift_document");
      return;
    }    
  };

  const handleInvoiceDocument = () => {
    if (orderdetails?.invoice_document?.url) {
      downloadFilefromUrl(
        orderdetails?.invoice_document.url,
        "invoice_document",
      );
      return;
    }
  };
  const calculateTotalAmount = (payments: any[] = []) => {
    return payments.reduce(
      (total, payment) => total + (payment.amount || 0),
      0,
    );
  };
  const totalAmount = calculateTotalAmount(orderdetails?._payments_of_order);
  const balance =
    (parseInt(orderdetails?.payable_amount.toFixed(2) as string)) - totalAmount;

  // customer rate
  const serviceRate = Number(orderdetails?.service_partner_rates) || 0;
  const marginLevel1 = Number(margin.l1) || 0;
  const marginLevel2 = Number(margin.l2) || 0;
  const marginLevel3 = Number(margin.l3) || 0;

  const totalMargin =
    Number(level) === 1
      ? marginLevel1
      : Number(level) === 2
        ? marginLevel1 + marginLevel2
        : marginLevel1 + marginLevel2 + marginLevel3;

  // Partner rate
  const partnerValue = (
    serviceRate + (Number(level) + 1 === 2 ? marginLevel2 : marginLevel3)
  ).toFixed(2);
  // for customer rate
  const totalValue =
    channelDetails?.id === 12
      ? (Number(partnerValue) + totalMargin).toFixed(2)
      : Number(partnerValue).toFixed(2);

  const refundCustomerRate =
    channelDetails?.id === 12
      ? (Number(partnerValue) - totalMargin).toFixed(2)
      : Number(partnerValue).toFixed(2);

  const StepIndicator = ({ orderdetails, margin, level }: any) => {
    const serviceRate = Number(orderdetails?.service_partner_rates) || 0;
    const marginLevel1 = Number(margin.l1) || 0;
    const marginLevel2 = Number(margin.l2) || 0;
    const marginLevel3 = Number(margin.l3) || 0;

    // Calculate total margin based on level
    const levelNum = Number(level);

    const totalMargin =
      levelNum === 1
        ? marginLevel1
        : levelNum === 2
          ? marginLevel1 + marginLevel2
          : marginLevel1 + marginLevel2 + marginLevel3;

    // Calculate margin rate for the specific level
    const marginRate =
      levelNum === 1
        ? marginLevel1
        : levelNum === 2
          ? marginLevel2
          : marginLevel3;
    // Calculate partner rate correctly
    const partnerRateValue = (serviceRate + marginRate).toFixed(2);

    // Calculate partner margin for the next level
    const PartnerMarginVal =
      levelNum === 1
        ? marginLevel2
        : levelNum === 2
          ? marginLevel2
          : marginLevel3;
    // Final customer rate value
    let CustomerRateValue =
      channelDetails?.id === 12
        ? (PartnerMarginVal + Number(partnerRateValue)).toFixed(2)
        : (serviceRate + marginRate).toFixed(2);
    if (orderdetails?.refund_order_id) {
      CustomerRateValue = orderdetails?.refund_customer_rate;
    }

    let steps = [
      { label: "Customer rate", value: `INR ${CustomerRateValue}` },
      { label: "Partner rate", value: `INR ${partnerRateValue}` },
      {
        label: "Settlement rate",
        value: `INR ${Number(serviceRate).toFixed(2)}`,
      },
    ];

    let steps1 = [
      { label: "Customer rate", value: `INR ${CustomerRateValue}` },
      { label: "My rate", value: `INR ${partnerRateValue}` },
    ];

    let finalSteps = checkLevel(LEVEL_2) ? steps1 : steps;

    if (channelDetails?.id !== 12) {
      const labelToRemove = checkLevel(LEVEL_2) ? "My rate" : "Partner rate";
      finalSteps = finalSteps.filter((step) => step.label !== labelToRemove);
    }

    return (
      <div className="flex flex-col gap-2 py-4">
        {finalSteps?.map((item, index) => (
          <div key={index} className="relative flex items-start gap-4">
            {/* Step Indicator with Connecting Line */}
            <div className="relative flex flex-col items-center">
              <img
                className="w-3 h-3"
                src="/images/overview/ellipse.svg"
                alt="Step"
              />
              {index < finalSteps?.length - 1 && (
                <div className="w-[2px] h-20 bg-blue-700 border-l-2 border-dashed" />
              )}
            </div>

            {/* Step Content */}
            <div className="flex flex-col gap-2">
              {item.label === "Partner rate" &&
              orderdetails?.refund_order_id ? null : (
                <span className="text-sm font-medium leading-[17px]">
                  {item.label}: {item.value}
                </span>
              )}

              {/* Partner Margin */}
              {index === 0 &&
                (checkLevel(LEVEL_2) ? true : channelDetails?.id === 12) && (
                  <div className="p-3 mt-2 bg-gray-100 rounded-lg">
                    <span className="text-sm text-[#666666] font-medium leading-[17px]">
                      {checkLevel(LEVEL_2) ? "My margin" : "Partner margin"}:
                      INR {PartnerMarginVal}
                    </span>
                  </div>
                )}

              {/* MoneeFlo Margin */}
              {index === (channelDetails?.id === 12 ? 1 : 0) &&
                !checkLevel(LEVEL_2) && (
                  <div className="p-3 mt-2 bg-gray-100 rounded-lg">
                    <span className="text-sm text-[#666666] font-medium leading-[17px]">
                      MoneeFlo margin: INR {marginRate}
                    </span>
                  </div>
                )}
            </div>
          </div>
        ))}
      </div>
    );
  };

  const handleDealRedirect = (event) => {
    event.preventDefault();
    dispatch(setIsDealflowCheck(true));
    navigate(`/remit/dealdetails/${dealID}`);
  };

  const isCaptureBtnStatus =
    parseInt(orderdetails?.payable_amount?.toString()) - payAmountVal;

  const handleApprove = async (
    status_AD2: string,
    notes: string,
    ack_no: number,
  ) => {
    setLoading(true);
    const auth = localStorage.getItem("authToken");
    if (!auth) return;
    const authToken = JSON.parse(auth);
    const payload: AxiosRequestConfig<POSTeditPaymentStatusRequestType> = {
      headers: { Authorization: `Bearer ${authToken}` },
      data: {
        order_id: Number(id),
        ack_no: Number(ack_no),
        status_AD2,
        notes,
      },
    };
    try {
      const response = await PaymentStatusAPI(payload);
      if (response?.status === 200) {
        setLoading(false);
        if (status_AD2 === "rejected") {
          toast.success("Payment rejected!!");
        } else toast.success("Payment approved successfully");
      }
    } catch (error) {
      toast.error("Failed to update partner details");
      setLoading(false);
    }
  };

  const handleResumeOrder = () => {
    const documentsData = orderdetails?.supporting_documents?.map(
      (doc: any) => {
        return {
          doc: doc?.file?.url as string,
          doc_name: doc?.filename,
          doc_id: doc?.doc_list_id,
          reupload: false,
        };
      },
    );
    dispatch(setPurposeId(orderdetails?._purpose.id as string));
    dispatch(setType("beneficiary_receives"));
    dispatch(setCreatedBy(orderdetails?._order_created_by?.id));
    dispatch(setDocs({ filename: null, file: null }));
    dispatch(setServicePartnerID(orderdetails?._order_service_partner?.id));
    dispatch(setDealId(dealID?.toString() as string));
    dispatch(setKycDocBase64({}));
    dispatch(setAdditionalDocBase64({}));
    dispatch(setAdditionalDocs([]));
    dispatch(setKycDocs([]));
    dispatch(setAllDocs(documentsData));
    dispatch(setOrderId(id));
    navigate("/createorder?type=resume", {
      state: {
        LeadID: dealID,
        ResumeOrderPage: true,
      },
    });
  };

  const handleLeadRedirect = (event: any) => {
    event.preventDefault();
    navigate(`/remit/leads`, {
      state: {
        LeadID: orderdetails?.opportunity_id,
        leadModalState: true,
      },
    });
  };

  const handleInitRefund = () => {
    dispatch(setPurpose(orderdetails?._purpose?.name));
    dispatch(setRefundOrderId(id));
    dispatch(setRefundPurposeId(orderdetails?._purpose?.id));
    dispatch(setSenderName(orderdetails?._order_customers?.full_name));
    dispatch(setAmountSent(orderdetails?.amount));
    dispatch(setCurrency(orderdetails?.currency));
    dispatch(
      setServicePartnerId(orderdetails?._order_service_partner?.id as string),
    );
    dispatch(setRefundCreatedBy(orderdetails?._order_created_by?.id));
    dispatch(setRefundDealId(dealID?.toString() as string));
    dispatch(setRefundTTRate(orderdetails?.tt_charges_inclgst));
    dispatch(
      setRefundForeignBankRate(orderdetails?.foreign_bank_rates_inclgst),
    );
    dispatch(setPartnerOrderId(orderdetails?.l2_channel?.toString() as string));
    dispatch(
      setServicePartnerBankId(
        orderdetails?._service_partner_bank_details?.at(-1)?.id,
      ),
    );
    dispatch(setDocuments(orderdetails?.supporting_documents));
    dispatch(
      setExtraDocument([
        {
          name: "Swift Copy",
          file: orderdetails?.swift_document,
        },
        {
          name: "Sender Aadhaar Front",
          file: orderdetails?._order_customers?.aadhaar_soft_copy_back,
        },
        {
          name: "Sender Aadhaar Back",
          file: orderdetails?._order_customers?.aadhaar_soft_copy_back,
        },
        {
          name: "Sender PAN",
          file: orderdetails?._order_customers?.pan_soft_copy,
        },
        {
          name: "Passport",
          file: orderdetails?.supporting_documents?.find(
            (item: any) => item?.doc_list_id === 24,
          )?.file,
        },
      ]),
    );
    navigate("/refund");
  };

  return (
    <>
      {loading && <Spinner />}
      <AlertDialog open={isTCSEditing} onOpenChange={setIsTCSEditing}>
        <AlertDialogPortal>
          <AlertDialogOverlay className=" bg-black-900 bg-opacity-60 animate-overlayShow fixed inset-0" />
          <AlertDialogContent className="bg-white-A700 rounded-lg p-0 max-w-md animate-contentShow">
            <form className="max-w-md">
              <AlertDialogHeader className="flex text-left gap-4 pt-8 pb-4 px-10 ">
                <AlertDialogTitle className="font-bold text-xl leading-7 tracking-[2%] text-black-label">
                  Edit TCS charges
                </AlertDialogTitle>
                <div className="border-b-2 border-gray-300 my-2 w-full"></div>
                <div className="flex flex-col gap-4">
                  <label
                    htmlFor="newTcs"
                    className="text-[14px] font-500 text-[#333333]"
                  >
                    New TCS charges
                  </label>
                  <div className="flex items-center border border-black/30 rounded-lg px-3 py-2">
                    <span className="bg-gray-100 border border-gray-300 rounded-lg text-gray-500 text-[15px] p-3">
                      INR
                    </span>
                    <input
                      className="flex-grow text-[15px] pl-4 border-none focus:outline-none"
                      type="number"
                      value={tcsValue}
                      onChange={(e) => setTcsValue(e.target.value)}
                      placeholder="Enter new TCS charges"
                    />
                  </div>

                  <div className="bg-gray-100 p-2 rounded-md">
                    <label htmlFor="currenttcs" className="text-sm font-medium">
                      Current TCS:{" "}
                      <span className="font-semibold">
                        {orderdetails?.tcs || 0}
                      </span>
                    </label>
                  </div>

                  <div className="flex items-center gap-2">
                    <input
                      type="checkbox"
                      id="tcsConfirmation"
                      className="w-4 h-4 cursor-not-allowed disabled:cursor-not-allowed"
                      required
                      checked={isChecked}
                      onChange={(e) => setIsChecked(e.target.checked)}
                      disabled={!tcsValue}
                    />
                    <label htmlFor="tcsConfirmation" className="text-sm">
                      I hereby declare the TCS charges are updated as confirmed
                      by {orderdetails?._order_service_partner?.display_name}.
                    </label>
                  </div>
                </div>
              </AlertDialogHeader>
              <AlertDialogFooter className="flex justify-end items-center gap-2.5 py-5 px-10 flex-row rounded-b-lg bg-gray-button-gray-lite">
                <AlertDialogCancel
                  className=" m-0 rounded-lg border-blue-700 border py-[11px] px-4 text-blue-700"
                  asChild
                >
                  <button onClick={handleTCSCancel}>Close</button>
                </AlertDialogCancel>
                {(orderdetails?.tcs || 0) > parseInt(tcsValue) ? (
                  <TCSWarning
                    tcs_amount={orderdetails?.tcs}
                    order_id={param?.id as string}
                    tcsValue={tcsValue}
                    handleSubmit={handleTCSSave}
                  >
                    <AlertDialogAction
                      className={`rounded-lg border-blue-700 py-[11px] px-4 bg-blue-700 border text-white-A700 ${
                        !isChecked ? "opacity-50 cursor-not-allowed" : ""
                      }`}
                    >
                      Save
                    </AlertDialogAction>
                  </TCSWarning>
                ) : (
                  <AlertDialogAction
                    type="submit"
                    onClick={() =>
                      handleTCSSave(
                        parseInt(param?.id as string),
                        "",
                        parseInt(tcsValue),
                      )
                    }
                    className={`rounded-lg border-blue-700 py-[11px] px-4 bg-blue-700 border text-white-A700 ${
                      !isChecked ? "opacity-50 cursor-not-allowed" : ""
                    }`}
                    disabled={!isChecked || !tcsValue}
                  >
                    Save
                  </AlertDialogAction>
                )}
              </AlertDialogFooter>
            </form>
          </AlertDialogContent>
        </AlertDialogPortal>
      </AlertDialog>
      {
        <div>
          {showcapturepayment && (
            <div
              style={{ backgroundColor: "rgba(0, 0, 0, .6)" }}
              className="fixed top-0 left-0 z-[10] h-screen w-[100vw] flex justify-center items-center"
            >
              <AddDeclaration
                orderID={id}
                setShowCapturePayment={setShowCapturePayment}
                OrderDetails={OrderDetails}
                remainingAmount={remainingAmount}
              />
            </div>
          )}
          {showUploadDocumentType !== "" && (
            <div
              style={{ backgroundColor: "rgba(0, 0, 0, .6)" }}
              className="fixed top-0 left-0 z-50 h-screen w-[100vw] flex justify-center items-center"
            >
              <UploadDocuments
                showUploadDocumentType={showUploadDocumentType}
                orderID={id}
                setShowUploadDocumentType={setShowUploadDocumentType}
                OrderDetails={OrderDetails}
              />
            </div>
          )}
          {showSettlementRate && (
            <div
              style={{ backgroundColor: "rgba(0, 0, 0, .6)" }}
              className="fixed top-0 left-0 z-[10] h-screen w-[100vw] flex justify-center items-center"
            >
              <SettlementRate
                setShowSettlementRate={setShowSettlementRate}
                id={id}
                orderdetails={orderdetails}
                OrderDetails={OrderDetails}
              />
            </div>
          )}
        </div>
      }

      {showimg && (
        <div
          style={{ backgroundColor: "rgba(0, 0, 0, .6)" }}
          className="fixed top-0 left-0 z-[10] h-screen w-[100vw] flex justify-center items-center"
        >
          {" "}
          <Img src={imgsrc} className="h-[300px] w-[400px]" alt="Loading...." />
          <button
            className="relative top-[-150px] left-[10px]"
            onClick={() => setShowimg(!showimg)}
          >
            <AiOutlineCloseCircle className="text-[30px] cursor-pointer" />
          </button>
        </div>
      )}
      <div className="flex-1 sm:flex-col overflow-hidden gap-x-3 w-full flex border-[#D9E0F7]">
        <div className="flex flex-col gap-5 h-full w-[80%] overflow-y-scroll overflow-x-hidden p-3 bg-white-A700 border rounded-xl">
          <div className="flex w-full gap-8 border-b-2 justify-between pb-5">
            <div className="flex justify-between items-center w-full">
              <div className=" flex flex-col gap-2">
                <div className="flex flex-row items-center gap-2">
                  <h3 className="font-semibold leading-4 text-lg text-black-label">
                    {orderdetails?._order_customers?.full_name}
                  </h3>
                  <span className="text-gray-400">•</span>
                  <h3 className="font-semibold leading-4 text-lg text-black-label">
                    {orderdetails?._purpose?.name}
                  </h3>
                  <span className="text-gray-400">•</span>
                  <span className="text-gray-500">Order ID: {id}</span>
                </div>

                <div>
                  <p className="font-normal leading-[22.4px] text-sm text-[#7E7E7E]">
                    {orderdetails?.created_at &&
                      new Date(orderdetails.created_at)
                        .toLocaleString("en-GB", {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                          hour: "2-digit",
                          minute: "2-digit",
                          hour12: true,
                        })
                        .replace(",", "")
                        .replace(" at", "")}{" "}
                    by {orderdetails?._order_created_by?.fname || "N/A"}
                    {!checkLevel(LEVEL_2) && (
                      <>
                        |{" "}
                        {channelDetails?.Channel === "Refferal"
                          ? "Referral"
                          : channelDetails?.Channel}{" "}
                        - {orderdetails?.partner_detail?.city || "N/A"}
                      </>
                    )}
                  </p>
                </div>
              </div>
              {
                !orderdetails?.refund_order_id &&
                (orderdetails?.payment_status === "recieved" ||
                  orderdetails?.status === "fulfilled" ||
                  (orderdetails?.status !== "processing" &&
                    orderdetails?.status !== "draftOrder")) && (
                  <div className="flex gap-3">
                    <Button
                      onClick={handleSwiftDocument}
                      className="rounded-lg py-[11px] flex gap-2 px-4 text-[#165FE3] font-semibold text-sm"
                    >
                      {(orderdetails?.swift_document?.url && checkLevel(LEVEL_2))
                        ? "Download SWIFT"
                        : "Upload SWIFT"}
                      <img
                        alt="upload icon"
                        src="/images/remit/uploadIcon.svg"
                        style={{ height: "20px", width: "20px" }}
                        className={`${(orderdetails?.swift_document?.url && checkLevel(LEVEL_2)) ? " rotate-180" : " rotate-0"}`}
                      />
                    </Button>
                    <Button
                      onClick={handleInvoiceDocument}
                      className="rounded-lg py-[11px] px-4 text-[#165FE3] flex gap-2 font-semibold text-sm"
                    >
                      {(orderdetails?.invoice_document?.url && checkLevel(LEVEL_2))
                        ? "Download Invoice"
                        : "Upload Invoice"}
                      <img
                        alt="upload icon"
                        src="/images/remit/uploadIcon.svg"
                        style={{ height: "20px", width: "20px" }}
                        className={`${(orderdetails?.invoice_document?.url && checkLevel(LEVEL_2)) ? " rotate-180" : " rotate-0"}`}
                      />
                    </Button>
                  </div>
                )}
              <Popover>
                {orderstatus === "fulfilled" && !checkLevel(LEVEL_2) &&
                  !orderdetails?.refund_order_id && (
                    <PopoverTrigger>
                      <svg
                        width="6"
                        height="20"
                        viewBox="0 0 6 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M3.0293 10.0117H3.01943V10.0217H3.0293V10.0117ZM3.0293 3.01172H3.01943V3.02172H3.0293V3.01172ZM3.0293 17.0117H3.01943V17.0217H3.0293V17.0117Z"
                          fill="black"
                          stroke="#292929"
                          stroke-width="4.36364"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </PopoverTrigger>
                  )}
                <PopoverContent
                  className="p-0 w-full"
                  align="end"
                  sideOffset={5}
                >
                  {                    
                    <button
                      onClick={handleInitRefund}
                      className="rounded-lg py-[11px] px-5 disabled:opacity-40 text-black-900 font-semibold text-sm"
                    >
                      Initiate Refund
                    </button>
                  }
                </PopoverContent>
              </Popover>
            </div>
            {!checkLevel(LEVEL_2) && orderdetails?.status === "draftOrder" && (
              <button
                onClick={() => handleResumeOrder()}
                className="rounded-lg py-[11px] whitespace-nowrap h-fit disabled:opacity-40 px-4 border bg-blue-700 text-white-A700 font-semibold text-sm"
              >
                Resume order
              </button>
            )}
          </div>

          {/* all tabs */}
          <Tabs
            value={activeTab}
            onValueChange={onTabChange}
            className=" sm:max-w-7xl sm:overflow-hidden"
          >
            <TabsList className="border-b border-[#C4D7F9] w-full hide-scrollbar flex justify-between rounded-none gap-2 h-12">
              {tabsdata.map((tab) => {
                if (
                  orderdetails?.refund_order_id &&
                  tab.value === "other-details"
                )
                  return null;
                return (
                  <TabsTrigger
                    key={tab.id}
                    value={tab.value}
                    className={`px-6 py-3.5 text-sm ${tab.value === activeTab && "border-t h-11 rounded-none font-semibold border-blue-700 text-blue-700 w-[215px] shadow bg-[#EFF4FF]"}`}
                  >
                    <div className="flex gap-2 items-center">
                      {tab.label}
                      {(() => {
                        const documentStatus =
                          orderdetails?.doc_status === "Review" ? false : true;
                        if (["payments", "documents"].includes(tab.value)) {
                          if (
                            tab.value === "payments" &&
                            (isCaptureBtnStatus < 0 || isCaptureBtnStatus === 0)
                          ) {
                            return (
                              <span className="">
                                <svg
                                  width="16"
                                  height="16"
                                  viewBox="0 0 16 16"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M8 0C3.592 0 0 3.592 0 8C0 12.408 3.592 16 8 16C12.408 16 16 12.408 16 8C16 3.592 12.408 0 8 0ZM11.824 6.16L7.288 10.696C7.176 10.808 7.024 10.872 6.864 10.872C6.704 10.872 6.552 10.808 6.44 10.696L4.176 8.432C3.944 8.2 3.944 7.816 4.176 7.584C4.408 7.352 4.792 7.352 5.024 7.584L6.864 9.424L10.976 5.312C11.208 5.08 11.592 5.08 11.824 5.312C12.056 5.544 12.056 5.92 11.824 6.16Z"
                                    fill="#00A82D"
                                  />
                                </svg>
                              </span>
                            );
                          } else if (
                            tab.value === "documents" &&
                            documentStatus
                          )
                            return (
                              <span className="">
                                <svg
                                  width="16"
                                  height="16"
                                  viewBox="0 0 16 16"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M8 0C3.592 0 0 3.592 0 8C0 12.408 3.592 16 8 16C12.408 16 16 12.408 16 8C16 3.592 12.408 0 8 0ZM11.824 6.16L7.288 10.696C7.176 10.808 7.024 10.872 6.864 10.872C6.704 10.872 6.552 10.808 6.44 10.696L4.176 8.432C3.944 8.2 3.944 7.816 4.176 7.584C4.408 7.352 4.792 7.352 5.024 7.584L6.864 9.424L10.976 5.312C11.208 5.08 11.592 5.08 11.824 5.312C12.056 5.544 12.056 5.92 11.824 6.16Z"
                                    fill="#00A82D"
                                  />
                                </svg>
                              </span>
                            );
                          else {
                            return (
                              <svg
                                width="17"
                                height="16"
                                viewBox="0 0 17 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M8.80078 0C4.39278 0 0.800781 3.592 0.800781 8C0.800781 12.408 4.39278 16 8.80078 16C13.2088 16 16.8008 12.408 16.8008 8C16.8008 3.592 13.2088 0 8.80078 0ZM12.6248 6.16L8.08878 10.696C7.97678 10.808 7.82478 10.872 7.66478 10.872C7.50478 10.872 7.35278 10.808 7.24078 10.696L4.97678 8.432C4.74478 8.2 4.74478 7.816 4.97678 7.584C5.20878 7.352 5.59278 7.352 5.82478 7.584L7.66478 9.424L11.7768 5.312C12.0088 5.08 12.3928 5.08 12.6248 5.312C12.8568 5.544 12.8568 5.92 12.6248 6.16Z"
                                  fill="#D2D2D2"
                                />
                              </svg>
                            );
                          }
                        }
                        return null;
                      })()}
                    </div>
                  </TabsTrigger>
                );
              })}
            </TabsList>
            <TabsContent
              className="p-3 gap-10 flex flex-col rounded-xl w-full overflow-auto"
              value="overview"
            >
              {orderdetails?.refund_order_id ? (
                <div className="flex flex-row gap-4 w-full h-full">
                  {/* Left Section */}
                  <div className="w-[70%] flex flex-col gap-4">
                    <div className="rounded-lg p-2 bg-[#E1EBFC] max-w-[520px] flex items-center gap-3 border border-blue-700">
                      <svg
                        width="16"
                        height="17"
                        viewBox="0 0 16 17"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M8 0.5C6.41775 0.5 4.87103 0.969192 3.55544 1.84824C2.23985 2.72729 1.21447 3.97672 0.608967 5.43853C0.00346632 6.90034 -0.15496 8.50887 0.153721 10.0607C0.462403 11.6126 1.22433 13.038 2.34315 14.1569C3.46197 15.2757 4.88743 16.0376 6.43928 16.3463C7.99113 16.655 9.59966 16.4965 11.0615 15.891C12.5233 15.2855 13.7727 14.2602 14.6518 12.9446C15.5308 11.629 16 10.0822 16 8.5C15.9978 6.37895 15.1542 4.34542 13.6544 2.84562C12.1546 1.34581 10.121 0.50224 8 0.5ZM7.69231 4.19231C7.87488 4.19231 8.05334 4.24644 8.20514 4.34787C8.35694 4.4493 8.47526 4.59347 8.54512 4.76214C8.61499 4.93081 8.63327 5.11641 8.59765 5.29547C8.56203 5.47453 8.47412 5.639 8.34502 5.7681C8.21593 5.89719 8.05145 5.98511 7.87239 6.02072C7.69333 6.05634 7.50773 6.03806 7.33906 5.9682C7.17039 5.89833 7.02623 5.78002 6.9248 5.62822C6.82337 5.47642 6.76923 5.29795 6.76923 5.11538C6.76923 4.87057 6.86649 4.63578 7.0396 4.46267C7.21271 4.28956 7.44749 4.19231 7.69231 4.19231ZM8.61539 12.8077C8.28897 12.8077 7.97592 12.678 7.7451 12.4472C7.51429 12.2164 7.38462 11.9033 7.38462 11.5769V8.5C7.22141 8.5 7.06488 8.43516 6.94947 8.31976C6.83407 8.20435 6.76923 8.04782 6.76923 7.88461C6.76923 7.7214 6.83407 7.56488 6.94947 7.44947C7.06488 7.33406 7.22141 7.26923 7.38462 7.26923C7.71104 7.26923 8.02409 7.3989 8.2549 7.62971C8.48572 7.86053 8.61539 8.17358 8.61539 8.5V11.5769C8.7786 11.5769 8.93512 11.6418 9.05053 11.7572C9.16594 11.8726 9.23077 12.0291 9.23077 12.1923C9.23077 12.3555 9.16594 12.512 9.05053 12.6274C8.93512 12.7429 8.7786 12.8077 8.61539 12.8077Z"
                          fill="#165FE3"
                        />
                      </svg>
                      <h1 className="text-[#666666] font-normal leading-[150%] -tracking-[1%]">
                        The refund for this order has been initiated{" "}
                        <a
                          href={`/orderdetails/${orderdetails?.refund_order_id}`}
                          className="text-blue-700 underline"
                        >
                          Order ID - {orderdetails?.refund_order_id} &#x2197;
                        </a>
                      </h1>
                    </div>

                    <div className="rounded-lg p-5 bg-[#FAFAFA] w-full flex flex-col gap-2">
                      <div className="flex justify-between items-center p-3 rounded-lg">
                        <h1 className="text-gray-400">FCY Amount</h1>
                        <div className="flex gap-5">
                          <p className="">
                            {orderdetails?.amount &&
                              formatCurrency(
                                parseInt(orderdetails?.amount.toFixed(0)),
                                orderdetails?.currency as string,
                              )}
                          </p>
                        </div>
                      </div>

                      <div className="flex justify-between items-center p-3 bg-white rounded-lg">
                        <h1 className="text-gray-400">
                          Total Amount Payable{" "}
                          <span
                            className="text-blue-500 underline cursor-pointer"
                            onClick={() => setTab("amount-charges")}
                          >
                            View Breakup
                          </span>
                        </h1>
                        <div className="flex text-blue-700 gap-5">
                          <p className="">
                            {formatCurrency(orderdetails?.amount_inr, "INR")}
                          </p>
                        </div>
                      </div>

                      <div className="flex justify-between items-center p-3 bg-white rounded-lg">
                        <h1 className="text-gray-400">Customer Rate:</h1>
                        <h1 className="text-black">
                          {formatCurrency(
                            orderdetails?.refund_customer_rate,
                            "INR",
                          )}
                        </h1>
                      </div>
                    </div>
                    <div className="rounded-lg p-2 bg-[#FAFAFA] w-full flex flex-col gap-2">
                      {!checkLevel(LEVEL_2) && (
                        <div className="flex justify-between items-center p-3 rounded-lg">
                          <h1 className="text-gray-400">My Margin:</h1>
                          <div className="flex items-center rounded-lg px-3">
                            <h1 className="text-black">
                              {level === "1"
                                ? formatCurrency(
                                    calculateProfit(
                                      Number(orderdetails?.amount),
                                      Number(
                                        orderdetails?.refund_customer_rate,
                                      ),
                                      Number(margin.l1),
                                    ),
                                    "INR",
                                  )
                                : level === "2"
                                  ? formatCurrency(
                                      calculateProfit(
                                        Number(orderdetails?.amount),
                                        Number(
                                          orderdetails?.refund_customer_rate,
                                        ),
                                        Number(margin.l2),
                                      ),
                                      "INR",
                                    )
                                  : margin.l3}
                            </h1>
                          </div>
                        </div>
                      )}
                      <div className="flex justify-between items-center p-3 bg-white rounded-lg">
                        <h1 className="text-gray-400">
                          {checkLevel(LEVEL_2)
                            ? "My margin"
                            : "Partner’s margin"}
                          :
                        </h1>
                        <h1 className="text-black">
                          {formatCurrency(
                            calculateProfit(
                              Number(orderdetails?.amount),
                              Number(orderdetails?.refund_customer_rate),
                              Number(margin.l2),
                            ),
                            "INR",
                          )}
                        </h1>
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-col w-[30%] h-full relative space-y-4">
                    <div className="h-full flex flex-col">
                      <TooltipProvider>
                        <Tooltip>
                          <TooltipTrigger
                            className="flex cursor-pointer items-center w-full md:w-auto"
                            asChild
                          >
                            <div className="flex items-center space-x-1">
                              <p className="text-[14px] font-500 md:text-base leading-[22px] md:leading-[25px] text-black-label">
                                Internal notes
                              </p>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-4 w-4 text-gray-500"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M18 10c0 4.418-3.582 8-8 8s-8-3.582-8-8 3.582-8 8-8 8 3.582 8 8zm-8-3a1 1 0 100 2 1 1 0 000-2zm-1 4a1 1 0 012 0v2a1 1 0 01-2 0v-2z"
                                  clipRule="evenodd"
                                />
                              </svg>
                            </div>
                          </TooltipTrigger>
                          <TooltipContent
                            side="bottom"
                            className="bg-black-900 text-white-A700 max-w-[200px] whitespace-normal break-words border-0"
                          >
                            <p className="text-[14px] font-medium md:text-base leading-[22px] md:leading-[25px]">
                              Visible to the {`${checkLevel(LEVEL_2) ? "moneeflo team" : "partner"}`}
                            </p>
                          </TooltipContent>
                        </Tooltip>
                      </TooltipProvider>
                      {!isEditing ? (
                        <div className="flex items-center gap-5 w-full">
                          <div className="bg-[#FAFAFA] w-full flex items-center gap-2 py-2.5 px-2 rounded-lg text-left">
                            <div
                              className="bg-[#FAFAFA] w-full flex items-center gap-2 py-2.5 px-2 rounded-lg text-left relative"
                              style={{ border: "1px solid #D2D2D2" }}
                            >
                              <div className="flex flex-col gap-1 max-h-[300px] overflow-y-scroll overflow-x-hidden pr-6">
                                <p className="font-400 text-[12px] leading-[18px] text-[#999999]">
                                  {orderdetails?.note_last_edited ? (
                                    <>
                                      Last edited on{" "}
                                      {formatUnixTimestamp(
                                        orderdetails?.note_last_edited,
                                      )}
                                    </>
                                  ) : (
                                    "Click on icon to add note"
                                  )}
                                </p>
                                <p className="font-normal text-base leading-[150%] break-words text-[#333333] whitespace-pre-wrap">
                                  {orderdetails?.note}
                                </p>
                              </div>

                              {!checkLevel(LEVEL_2) && (
                                <button
                                  onClick={openDetailNote}
                                  className="absolute top-[10px] right-2"
                                >
                                  <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M3.33594 4.24609H2.5026C2.06058 4.24609 1.63665 4.42169 1.32409 4.73425C1.01153 5.04681 0.835938 5.47073 0.835938 5.91276V13.4128C0.835938 13.8548 1.01153 14.2787 1.32409 14.5913C1.63665 14.9038 2.06058 15.0794 2.5026 15.0794H10.0026C10.4446 15.0794 10.8686 14.9038 11.1811 14.5913C11.4937 14.2787 11.6693 13.8548 11.6693 13.4128V12.5794"
                                      stroke="#165FE3"
                                      strokeWidth="1.5"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                    <path
                                      d="M10.8333 2.58472L13.3333 5.08472M14.4875 3.90556C14.8157 3.57735 15.0001 3.13221 15.0001 2.66806C15.0001 2.20391 14.8157 1.75876 14.4875 1.43056C14.1593 1.10235 13.7142 0.917969 13.25 0.917969C12.7858 0.917969 12.3407 1.10235 12.0125 1.43056L5 8.41806V10.9181H7.5L14.4875 3.90556Z"
                                      stroke="#165FE3"
                                      strokeWidth="1.5"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                  </svg>
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className="w-full flex flex-col gap-2">
                          <textarea
                            value={tempNote || note}
                            placeholder="Enter note"
                            className="font-normal text-base leading-[150%] border border-gray-400 rounded-lg p-4 w-full h-[250px] bg-white"
                            onChange={(e) => setTempNote(e.target.value)}
                            rows={5}
                          />
                          <div className="flex justify-end gap-2">
                            <button
                              onClick={() =>
                                handleSave(
                                  parseInt(param?.id as string),
                                  tempNote,
                                )
                              }
                              className="text-white-A700 bg-blue-700 text-sm rounded-lg py-1.5 px-3 hover:bg-blue-700"
                            >
                              Save
                            </button>
                            <button
                              onClick={() => setIsEditing(false)}
                              className="text-gray-600 bg-gray-300 text-sm rounded-lg py-1.5 px-3 hover:bg-gray-400"
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ) : (
                <div className="flex flex-row gap-4 w-full h-full">
                  {/* Left Section */}
                  <div className="w-[70%] flex flex-col gap-4">
                    <div className="rounded-lg p-2 bg-[#FFEAC9] w-[400px]">
                      <h1 className="text-[#000]">
                        This order has been created from deal{" "}
                        <a
                          href={`/remit/dealdetails/${dealID}`}
                          className="text-blue-600 underline"
                          onClick={handleDealRedirect}
                        >
                          ID - {dealID}
                        </a>
                      </h1>
                    </div>
                    <div className="rounded-lg p-5 bg-[#FAFAFA] w-full">
                      <div className="flex gap-4">
                        <h1 className="text-gray-400">Beneficiary:</h1>
                        <h1 className="text-black">
                          {" "}
                          {orderdetails?._beneficiary?.name || "N/A"}
                        </h1>
                      </div>
                      <div className="flex gap-4">
                        <h1 className="text-gray-400">Purpose:</h1>
                        <h1 className="text-black">
                          {orderdetails?._purpose?.name}
                        </h1>
                      </div>
                      <div className="flex gap-4">
                        <h1 className="text-gray-400">Student:</h1>
                        <h1 className="text-black">
                          {studentName?.value || "N/A"}{" "}
                        </h1>
                      </div>
                    </div>

                    <div className="rounded-lg p-5 bg-[#FAFAFA] w-full flex flex-col gap-2">
                      <div className="flex justify-between items-center p-3 rounded-lg">
                        <h1 className="text-gray-400">FCY Amount</h1>
                        <div className="flex gap-5">
                          <p className="">
                            {orderdetails?.amount &&
                              formatCurrency(
                                parseInt(orderdetails?.amount.toFixed(0)),
                                orderdetails?.currency as string,
                              )}
                          </p>
                        </div>
                      </div>

                      <div className="flex justify-between items-center p-3 bg-white rounded-lg">
                        <h1 className="text-gray-400">
                          Total Amount Payable{" "}
                          <span
                            className="text-blue-500 underline cursor-pointer"
                            onClick={() => setTab("amount-charges")}
                          >
                            View Breakup
                          </span>
                        </h1>
                        <div className="flex text-blue-700 gap-5">
                          <p className="">
                            {formatCurrency(
                              parseInt(
                                orderdetails?.payable_amount.toFixed(
                                  2,
                                ) as string,
                              ),
                              "INR",
                            )}
                          </p>
                        </div>
                      </div>

                      <div className="flex justify-between items-center p-3 bg-[#FF000012] rounded-lg">
                        <h1 className="text-red-400">Balance:</h1>
                        <div className="flex gap-5">
                          <p className="">
                            {formatCurrency(
                              parseInt(
                                isCaptureBtnStatus.toFixed(
                                  2,
                                ) as string,
                              ),
                              "INR",
                            )}
                          </p>
                        </div>
                      </div>

                      <div className="flex justify-between items-center p-3 bg-white rounded-lg">
                        <h1 className="text-gray-400">Customer Rate:</h1>
                        <h1 className="text-black">INR {totalValue}</h1>
                      </div>
                    </div>
                    <div className="rounded-lg p-2 bg-[#FAFAFA] w-full flex flex-col gap-2">                      
                      <div className="flex justify-between items-center p-3 bg-white rounded-lg">
                        <h1 className="text-gray-400">
                            My margin :
                        </h1>
                        <h1 className="text-black">INR {profits?.l2_profit}</h1>
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-col w-[30%] h-full relative space-y-4">
                    <div className="h-full flex flex-col">
                      <TooltipProvider>
                        <Tooltip>
                          <TooltipTrigger
                            className="flex cursor-pointer items-center w-full md:w-auto"
                            asChild
                          >
                            <div className="flex items-center space-x-1">
                              <p className="text-[14px] font-500 md:text-base leading-[22px] md:leading-[25px] text-black-label">
                                Internal notes
                              </p>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-4 w-4 text-gray-500"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M18 10c0 4.418-3.582 8-8 8s-8-3.582-8-8 3.582-8 8-8 8 3.582 8 8zm-8-3a1 1 0 100 2 1 1 0 000-2zm-1 4a1 1 0 012 0v2a1 1 0 01-2 0v-2z"
                                  clipRule="evenodd"
                                />
                              </svg>
                            </div>
                          </TooltipTrigger>
                          <TooltipContent
                            side="bottom"
                            className="bg-black-900 text-white-A700 max-w-[200px] whitespace-normal break-words border-0"
                          >
                            <p className="text-[14px] font-medium md:text-base leading-[22px] md:leading-[25px]">
                              Visible to the {`${checkLevel(LEVEL_2) ? "moneeflo team" : "partner"}`}
                            </p>
                          </TooltipContent>
                        </Tooltip>
                      </TooltipProvider>
                      {!isEditing ? (
                        <div className="flex items-center gap-5 w-full">
                          <div className="bg-[#FAFAFA] w-full flex items-center gap-2 py-2.5 px-2 rounded-lg text-left">
                            <div
                              className="bg-[#FAFAFA] w-full flex items-center gap-2 py-2.5 px-2 rounded-lg text-left relative"
                              style={{ border: "1px solid #D2D2D2" }}
                            >
                              <div className="flex flex-col gap-1 max-h-[300px] overflow-y-scroll overflow-x-hidden pr-6">
                                <p className="font-400 text-[12px] leading-[18px] text-[#999999]">
                                  {orderdetails?.note_last_edited ? (
                                    <>
                                      Last edited on{" "}
                                      {formatUnixTimestamp(
                                        orderdetails?.note_last_edited,
                                      )}
                                    </>
                                  ) : (
                                    "Click on icon to add note"
                                  )}
                                </p>
                                <p className="font-normal text-base leading-[150%] break-words text-[#333333] whitespace-pre-wrap">
                                  {orderdetails?.note}
                                </p>
                              </div>

                              {!checkLevel(LEVEL_2) && (
                                <button
                                  onClick={openDetailNote}
                                  className="absolute top-[10px] right-2"
                                >
                                  <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M3.33594 4.24609H2.5026C2.06058 4.24609 1.63665 4.42169 1.32409 4.73425C1.01153 5.04681 0.835938 5.47073 0.835938 5.91276V13.4128C0.835938 13.8548 1.01153 14.2787 1.32409 14.5913C1.63665 14.9038 2.06058 15.0794 2.5026 15.0794H10.0026C10.4446 15.0794 10.8686 14.9038 11.1811 14.5913C11.4937 14.2787 11.6693 13.8548 11.6693 13.4128V12.5794"
                                      stroke="#165FE3"
                                      strokeWidth="1.5"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                    <path
                                      d="M10.8333 2.58472L13.3333 5.08472M14.4875 3.90556C14.8157 3.57735 15.0001 3.13221 15.0001 2.66806C15.0001 2.20391 14.8157 1.75876 14.4875 1.43056C14.1593 1.10235 13.7142 0.917969 13.25 0.917969C12.7858 0.917969 12.3407 1.10235 12.0125 1.43056L5 8.41806V10.9181H7.5L14.4875 3.90556Z"
                                      stroke="#165FE3"
                                      strokeWidth="1.5"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                  </svg>
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className="w-full flex flex-col gap-2">
                          <textarea
                            value={tempNote || note}
                            placeholder="Enter note"
                            className="font-normal text-base leading-[150%] border border-gray-400 rounded-lg p-4 w-full h-[250px] bg-white"
                            onChange={(e) => setTempNote(e.target.value)}
                            rows={5}
                          />
                          <div className="flex justify-end gap-2">
                            <button
                              onClick={() =>
                                handleSave(
                                  parseInt(param?.id as string),
                                  tempNote,
                                )
                              }
                              className="text-white-A700 bg-blue-700 text-sm rounded-lg py-1.5 px-3 hover:bg-blue-700"
                            >
                              Save
                            </button>
                            <button
                              onClick={() => setIsEditing(false)}
                              className="text-gray-600 bg-gray-300 text-sm rounded-lg py-1.5 px-3 hover:bg-gray-400"
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </TabsContent>
            <TabsContent value="amount-charges">
              {orderdetails?.refund_order_id ? (
                <section className="bg-white-A700 px-3 py-5 rounded-xl gap-4 flex flex-col">
                  <div className="pt-5 pb-10 px-5 rounded-xl shadow-order-summary gap-10">
                    <div className="divide-y divide-neutral-400_1 gap-5 flex flex-col">
                      <div className="flex flex-col gap-4 w-full">
                        <div className="flex justify-between w-full">
                          <span className="text-sm indent-3.5 text-[#666666]">
                            Customer Rate
                          </span>
                          <div>
                            <span className="text-sm font-medium">
                              {formatCurrency(
                                parseInt(
                                  orderdetails?.refund_customer_rate as string,
                                ),
                                "INR",
                              )}
                            </span>
                          </div>
                        </div>
                        <div className="flex justify-between w-full">
                          <span className="text-sm indent-3.5 text-[#666666]">
                            Recipient gets
                          </span>
                          <div className="text-sm font-medium">
                            <span>
                              {orderdetails?.amount &&
                                formatCurrency(
                                  parseInt(orderdetails?.amount.toFixed(0)),
                                  orderdetails?.currency as string,
                                )}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="flex justify-between pt-2.5 text-blue-700 w-full">
                        <span className="text-md indent-3.5 font-semibold">
                          Total Estimation
                        </span>
                        <div className="flex gap-1 items-center ">
                          <span className="text-md font-medium">
                            {formatCurrency(
                              parseInt(orderdetails?.amount_inr),
                              "INR",
                            )}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mt-4">
                    <Accordion
                      className="w-full sm:w-full"
                      type="single"
                      collapsible
                    >
                      <AccordionItem
                        value="address"
                        className="sm:w-full border-none underline-none"
                      >
                        <AccordionTrigger className="disabled:opacity-40 px-4 py-3 rounded-lg bg-[#FAFAFA] no-underline hover:no-underline border-none">
                          <div className="flex justify-between items-center w-full">
                            <div className="flex items-center gap-2">
                              <span className="text-base font-medium">
                                View Internal Transaction Breakup
                              </span>
                            </div>
                          </div>
                        </AccordionTrigger>
                        <AccordionContent className="w-full pl-6 sm:w-full">
                          <StepIndicator
                            orderdetails={orderdetails}
                            margin={margin}
                            level={level}
                          />
                        </AccordionContent>
                      </AccordionItem>
                    </Accordion>
                  </div>
                </section>
              ) : (
                <section className="bg-white-A700 px-3 py-5 rounded-xl gap-4 flex flex-col">
                  <p className="text-[#666666] leading-4 font-semibold">
                    Order Summary
                  </p>
                  <div className="pt-5 pb-10 px-5 rounded-xl shadow-order-summary gap-10">
                    <div className="divide-y divide-neutral-400_1 gap-5 flex flex-col">
                      <div className="flex flex-col gap-4 w-full">
                        <div className="flex justify-between w-full">
                          <span className="text-sm indent-3.5 text-[#666666]">
                            FX Amount
                          </span>
                          <div>
                            <span className="text-sm font-medium">
                              {formatCurrency(
                                orderdetails?.amount as number,
                                orderdetails?.currency as string,
                              )}
                            </span>
                          </div>
                        </div>
                        <div className="flex justify-between w-full">
                          <span className="text-sm indent-3.5 text-[#666666]">
                            Total Charges
                          </span>
                          <div className="text-sm font-medium">
                            <span>
                              {formatCurrency(
                                parseFloat(
                                  Number(
                                    Number(orderdetails?.gst) +
                                      Number(orderdetails?.tcs) +
                                      Number(orderdetails?.tt_charges_inclgst) +
                                      Number(
                                        orderdetails?.foreign_bank_rates_inclgst,
                                      ),
                                  )?.toFixed(4),
                                ),
                                "INR",
                              )}
                            </span>
                          </div>
                        </div>
                        <div className="w-full border-[.3px]" />
                        <div className="flex flex-col w-full gap-4">
                          <div className="flex justify-between w-full">
                            <span className="text-sm indent-3.5 text-[#666666]">
                              GST on FX conversion
                            </span>
                            <span className="text-sm font-medium">
                              {formatCurrency(
                                Number(orderdetails?.gst?.toFixed(2) as string),
                                "INR",
                              )}
                            </span>
                          </div>
                          <div className="flex justify-between w-full mb-2">
                            <span className="text-sm indent-3.5 text-[#666666]">
                              TCS{" "}
                              <span className="text-xs text-gray-500">
                                (incl. GST)
                              </span>
                            </span>
                            {/* <span className="text-sm font-medium">
                            {formatCurrency(
                              Number(orderdetails?.tcs?.toFixed(2) as string),
                              "INR",
                            )}
                          </span> */}
                            <div className="flex items-center gap-2">
                              <span className="text-sm font-medium">
                                {orderdetails?.tcs &&
                                  `INR ${parseFloat(orderdetails?.tcs.toFixed(2))}`}
                              </span>

                              {!checkLevel(LEVEL_2) && (
                                <button
                                  onClick={() => setIsTCSEditing(true)}
                                  disabled={challanState?.status === true}
                                  className="text-gray-500 hover:text-black disabled:opacity-40"
                                >
                                  <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M3.33594 4.24609H2.5026C2.06058 4.24609 1.63665 4.42169 1.32409 4.73425C1.01153 5.04681 0.835938 5.47073 0.835938 5.91276V13.4128C0.835938 13.8548 1.01153 14.2787 1.32409 14.5913C1.63665 14.9038 2.06058 15.0794 2.5026 15.0794H10.0026C10.4446 15.0794 10.8686 14.9038 11.1811 14.5913C11.4937 14.2787 11.6693 13.8548 11.6693 13.4128V12.5794"
                                      stroke="#165FE3"
                                      strokeWidth="1.5"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                    <path
                                      d="M10.8333 2.58472L13.3333 5.08472M14.4875 3.90556C14.8157 3.57735 15.0001 3.13221 15.0001 2.66806C15.0001 2.20391 14.8157 1.75876 14.4875 1.43056C14.1593 1.10235 13.7142 0.917969 13.25 0.917969C12.7858 0.917969 12.3407 1.10235 12.0125 1.43056L5 8.41806V10.9181H7.5L14.4875 3.90556Z"
                                      stroke="#165FE3"
                                      strokeWidth="1.5"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                  </svg>
                                </button>
                              )}
                            </div>
                          </div>
                          <div className="flex justify-between w-full">
                            <span className="text-sm indent-3.5 text-[#666666]">
                              TT charges{" "}
                              <span className="text-xs text-gray-500">
                                (incl. GST)
                              </span>
                            </span>
                            <span className="text-sm font-medium">
                              {formatCurrency(
                                Number(
                                  orderdetails?.tt_charges_inclgst?.toFixed(
                                    2,
                                  ) as string,
                                ),
                                "INR",
                              )}
                            </span>
                          </div>
                          <div className="flex justify-between w-full">
                            <span className="text-sm indent-3.5 text-[#98BDFF]">
                              Discount <span className="text-xs">%</span>
                            </span>
                          </div>
                          <div className="flex justify-between w-full mb-2">
                            <span className="text-sm indent-3.5 text-[#666666]">
                              Foreign Bank charges{" "}
                              <span className="text-xs text-gray-500">
                                (incl. GST)
                              </span>
                            </span>
                            <span className="text-sm font-medium">
                              {orderdetails?.foreign_bank_rates_inclgst?.toFixed(
                                2,
                              )}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="flex justify-between pt-2.5 text-blue-700 w-full">
                        <span className="text-md indent-3.5 font-semibold">
                          Total amount payable
                        </span>
                        <div className="flex gap-1 items-center ">
                          <span className="text-md font-medium">
                            {formatCurrency(
                              parseInt(
                                orderdetails?.payable_amount.toFixed(
                                  2,
                                ) as string,
                              ),
                              "INR",
                            )}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mt-4">
                    <Accordion
                      className="w-full sm:w-full"
                      type="single"
                      collapsible
                    >
                      <AccordionItem value="address" className="sm:w-full">
                        <AccordionTrigger className="disabled:opacity-40 px-4 py-3 rounded-lg bg-gray-300">
                          <div className="flex justify-between items-center w-full">
                            <div className="flex items-center gap-2">
                              <span className="text-base font-medium">
                                View Internal Transaction Breakup
                              </span>
                            </div>
                          </div>
                        </AccordionTrigger>
                        <AccordionContent className="w-full pl-6 sm:w-full">
                          <StepIndicator
                            orderdetails={orderdetails}
                            margin={margin}
                            level={level}
                          />
                        </AccordionContent>
                      </AccordionItem>
                    </Accordion>
                  </div>
                </section>
              )}
            </TabsContent>
            <TabsContent value="documents" className="px-2">
              {orderdetails?.refund_order_id ? (
                orderdetails?.supporting_documents?.length === 0 ? (
                  <div className="flex flex-col justify-center items-center w-full h-full">
                    <h1 className="text-gray-400 text-lg font-medium">
                      No documents available
                    </h1>
                  </div>
                ) : (
                  <div className="space-y-8">
                    <div className="space-y-2.5">
                      <h1 className="text-[#999999] text-sm font-medium leading-[100%]">
                        Supporting Documents
                      </h1>
                      {[
                        {
                          name: "Swift Copy",
                          file: orderdetails?.swift_document,
                        },
                        {
                          name: "Sender Aadhaar Front",
                          file: orderdetails?._order_customers
                            ?.aadhaar_soft_copy_back,
                        },
                        {
                          name: "Sender Aadhaar Back",
                          file: orderdetails?._order_customers
                            ?.aadhaar_soft_copy_back,
                        },
                        {
                          name: "Sender PAN",
                          file: orderdetails?._order_customers?.pan_soft_copy,
                        },
                        {
                          name: "Passport",
                          file: orderdetails?.supporting_documents?.find(
                            (item: any) => item?.doc_list_id === 24,
                          )?.file,
                        },
                      ]?.map((item: any, index: number) => {
                        return (
                          <div
                            key={index}
                            className="px-4 py-2 justify-between w-full rounded-md items-center flex even:bg-[#FAFAFA]"
                          >
                            <div className="flex flex-col overflow-hidden gap-5">
                              <h3 className="text-base font-medium text-gray-800">
                                {item?.name}
                              </h3>
                            </div>
                            <div className="flex items-center gap-5">
                              {true ? (
                                <div className="flex items-center gap-2">
                                  <a
                                    href={item?.file?.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-blue-600 underline underline-offset-2 hover:underline text-sm"
                                  >
                                    View
                                  </a>
                                  <svg
                                    width="18"
                                    height="13"
                                    viewBox="0 0 18 13"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M16.0642 5.78375C16.2922 6.10325 16.4062 6.26375 16.4062 6.5C16.4062 6.737 16.2922 6.89675 16.0642 7.21625C15.0397 8.65325 12.423 11.75 8.90625 11.75C5.38875 11.75 2.77275 8.6525 1.74825 7.21625C1.52025 6.89675 1.40625 6.73625 1.40625 6.5C1.40625 6.263 1.52025 6.10325 1.74825 5.78375C2.77275 4.34675 5.3895 1.25 8.90625 1.25C12.4237 1.25 15.0397 4.3475 16.0642 5.78375Z"
                                      stroke="#165FE3"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M11.1562 6.5C11.1562 5.90326 10.9192 5.33097 10.4972 4.90901C10.0753 4.48705 9.50299 4.25 8.90625 4.25C8.30951 4.25 7.73722 4.48705 7.31526 4.90901C6.8933 5.33097 6.65625 5.90326 6.65625 6.5C6.65625 7.09674 6.8933 7.66903 7.31526 8.09099C7.73722 8.51295 8.30951 8.75 8.90625 8.75C9.50299 8.75 10.0753 8.51295 10.4972 8.09099C10.9192 7.66903 11.1562 7.09674 11.1562 6.5Z"
                                      stroke="#165FE3"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                  </svg>
                                </div>
                              ) : null}
                              <div className="flex items-center gap-2"></div>
                              <input
                                type="file"
                                className="hidden"
                                accept="image/*,application/pdf"
                              />
                            </div>
                          </div>
                        );
                      })}
                    </div>
                    <div className="space-y-2.5">
                      <h1 className="text-[#999999] text-sm font-medium leading-[100%]">
                        Old bank documents
                      </h1>
                      {orderdetails?.supporting_documents
                        ?.filter(
                          (item: any) =>
                            bank_doc_ids.includes(item?.doc_list_id) &&
                            item?.refund_doc === false,
                        )
                        ?.map((item: any) => {
                          return (
                            <div
                              key={item?.doc_list_id}
                              className="px-4 py-2 justify-between w-full rounded-md items-center flex even:bg-[#FAFAFA]"
                            >
                              <div className="flex flex-col overflow-hidden gap-5">
                                <div className="flex items-center gap-5">
                                  <p className="text-base font-medium text-gray-800 ">
                                    {item?.filename}
                                  </p>
                                  <p className="text-[#999999] text-xs">
                                    {formatUnixTimestamp(item?.created_at)}
                                  </p>
                                </div>
                              </div>
                              <div className="flex items-center gap-5">
                                {true ? (
                                  <div className="flex items-center gap-2">
                                    <a
                                      href={item?.file?.url}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="text-blue-600 underline underline-offset-2 hover:underline text-sm"
                                    >
                                      View
                                    </a>
                                    <svg
                                      width="18"
                                      height="13"
                                      viewBox="0 0 18 13"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M16.0642 5.78375C16.2922 6.10325 16.4062 6.26375 16.4062 6.5C16.4062 6.737 16.2922 6.89675 16.0642 7.21625C15.0397 8.65325 12.423 11.75 8.90625 11.75C5.38875 11.75 2.77275 8.6525 1.74825 7.21625C1.52025 6.89675 1.40625 6.73625 1.40625 6.5C1.40625 6.263 1.52025 6.10325 1.74825 5.78375C2.77275 4.34675 5.3895 1.25 8.90625 1.25C12.4237 1.25 15.0397 4.3475 16.0642 5.78375Z"
                                        stroke="#165FE3"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                      <path
                                        d="M11.1562 6.5C11.1562 5.90326 10.9192 5.33097 10.4972 4.90901C10.0753 4.48705 9.50299 4.25 8.90625 4.25C8.30951 4.25 7.73722 4.48705 7.31526 4.90901C6.8933 5.33097 6.65625 5.90326 6.65625 6.5C6.65625 7.09674 6.8933 7.66903 7.31526 8.09099C7.73722 8.51295 8.30951 8.75 8.90625 8.75C9.50299 8.75 10.0753 8.51295 10.4972 8.09099C10.9192 7.66903 11.1562 7.09674 11.1562 6.5Z"
                                        stroke="#165FE3"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                    </svg>
                                  </div>
                                ) : null}
                                <div className="flex items-center gap-2"></div>
                                <input
                                  type="file"
                                  className="hidden"
                                  accept="image/*,application/pdf"
                                />
                              </div>
                            </div>
                          );
                        })}
                    </div>
                    <div className="space-y-2.5">
                      <h1 className="text-[#999999] text-sm font-medium leading-[100%]">
                        Updated bank documents
                      </h1>
                      {orderdetails?.supporting_documents
                        ?.filter(
                          (item: any) =>
                            bank_doc_ids.includes(item?.doc_list_id) &&
                            item?.refund_doc === true,
                        )
                        ?.map((item: any) => {
                          return (
                            <div
                              key={item?.doc_list_id}
                              className="px-4 py-2 justify-between w-full rounded-md items-center flex even:bg-[#FAFAFA]"
                            >
                              <div className="flex flex-col overflow-hidden gap-5">
                                <div className="flex items-center gap-5">
                                  <p className="text-base font-medium text-gray-800 ">
                                    {item?.filename}
                                  </p>
                                  <p className="text-[#999999] text-xs">
                                    {formatUnixTimestamp(item?.updated_at)}
                                  </p>
                                </div>
                              </div>
                              <div className="flex items-center gap-5">
                                {true ? (
                                  <div className="flex items-center gap-2">
                                    <a
                                      href={item?.file?.url}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="text-blue-600 underline underline-offset-2 hover:underline text-sm"
                                    >
                                      View
                                    </a>
                                    <svg
                                      width="18"
                                      height="13"
                                      viewBox="0 0 18 13"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M16.0642 5.78375C16.2922 6.10325 16.4062 6.26375 16.4062 6.5C16.4062 6.737 16.2922 6.89675 16.0642 7.21625C15.0397 8.65325 12.423 11.75 8.90625 11.75C5.38875 11.75 2.77275 8.6525 1.74825 7.21625C1.52025 6.89675 1.40625 6.73625 1.40625 6.5C1.40625 6.263 1.52025 6.10325 1.74825 5.78375C2.77275 4.34675 5.3895 1.25 8.90625 1.25C12.4237 1.25 15.0397 4.3475 16.0642 5.78375Z"
                                        stroke="#165FE3"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                      <path
                                        d="M11.1562 6.5C11.1562 5.90326 10.9192 5.33097 10.4972 4.90901C10.0753 4.48705 9.50299 4.25 8.90625 4.25C8.30951 4.25 7.73722 4.48705 7.31526 4.90901C6.8933 5.33097 6.65625 5.90326 6.65625 6.5C6.65625 7.09674 6.8933 7.66903 7.31526 8.09099C7.73722 8.51295 8.30951 8.75 8.90625 8.75C9.50299 8.75 10.0753 8.51295 10.4972 8.09099C10.9192 7.66903 11.1562 7.09674 11.1562 6.5Z"
                                        stroke="#165FE3"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                    </svg>
                                  </div>
                                ) : null}
                                <div className="flex items-center gap-2"></div>
                                <input
                                  type="file"
                                  className="hidden"
                                  accept="image/*,application/pdf"
                                />
                              </div>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                )
              ) : (
                <OrderDocuments
                  refetchOrderDetails={
                    OrderDetails as unknown as () => Promise<void>
                  }
                  order_id={id}
                  lrs_list={orderdetails?.customer_discloser_id?.map(
                    (doc: any, i: number) => {
                      return {
                        id: doc?.id as string,
                        ref_no: i + 1,
                        doc_url: doc?.supporting_document?.url,
                        amount: doc?.amount,
                        createdAt: doc?.date,
                      };
                    },
                  )}
                  doc_list={orderdetails?.supporting_documents.map(
                    (doc: any) => {
                      return {
                        doc_name: doc?.filename as string,
                        doc_status: doc?.status as string,
                        upload_date: doc?.created_at as string,
                        doc_id: doc?.document_id as string,
                        doc_list_id: doc?.doc_list_id as string,
                        doc_url: doc?.file?.url as string,
                        type: doc?.file?.type as string,
                        // url: doc?.file?.url as string,
                      };
                    },
                  )}
                  doc_status="Review"
                />
              )}
            </TabsContent>
            <TabsContent value="payments">
              {orderdetails?.refund_order_id ? (
                <section className="bg-white-A700 px-3 pb-5 rounded-xl gap-5 flex flex-col">
                  <div className="flex justify-between">
                    <div className="flex gap-5 items-center">
                      <p className="leading-4 font-semibold">Payments</p>
                      <p
                        style={{
                          backgroundColor: order_status_options.find(
                            (status) => orderdetails?.status === status.value,
                          )?.bgColor,
                          color: order_status_options.find(
                            (status) => orderdetails?.status === status.value,
                          )?.textColor,
                        }}
                        className="py-[4px] text-sm leading-4 capitalize font-medium  px-2 text-center rounded-md"
                      >
                        {orderdetails?.payment_status === "recieved" || (UTRData && UTRData.length > 0)
                          ? "Received"
                          : "Pending"}
                      </p>
                    </div>
                    <AlertDialog open={dialogOpen} onOpenChange={setDialogOpen}>
                      <AlertDialogTrigger className="">
                        <button 
                          className="rounded-lg py-[11px] disabled:opacity-40 px-4 border bg-blue-700 text-white-A700 font-semibold text-sm"
                          disabled={orderdetails?.payment_status === "recieved" || (UTRData && UTRData.length > 0)}
                        >
                          Capture UTR
                        </button>
                      </AlertDialogTrigger>
                      <AlertDialogPortal>
                        <AlertDialogOverlay className=" bg-black-900 bg-opacity-60 animate-overlayShow fixed inset-0" />
                        <AlertDialogContent className="bg-white-A700 rounded-lg p-0 max-w-md animate-contentShow">
                          <AlertDialogHeader className="flex text-left gap-4 ">
                            <AlertDialogTitle className="font-bold border-b w-full text-xl pt-8 pb-4 px-10 leading-7 tracking-[2%] text-black-label">
                              Capture UTR
                            </AlertDialogTitle>
                          </AlertDialogHeader>
                          <form className="max-w-md">
                            <div className="flex flex-col text-left gap-4 px-10">
                              <div className="flex gap-2 flex-shrink flex-col w-full">
                                <label
                                  htmlFor="acknowledgement_no"
                                  className=" text-sm font-medium leading-4"
                                >
                                  UTR Number
                                </label>
                                <input
                                  className="border focus:border-blue-700 p-3 rounded-lg"
                                  id="acknowledgement_no"
                                  type="number"
                                  {...register("utr_no", {
                                    required: "UTR Number is required",
                                  })}
                                  placeholder="Enter UTR number"
                                />
                                {errors.utr_no && (
                                  <p className="text-red-500 text-xs mt-1">
                                    {errors.utr_no.message as string}
                                  </p>
                                )}
                              </div>
                              <div className="flex gap-2 flex-1 flex-grow flex-col w-full">
                                <h3 className=" text-sm font-medium leading-4">
                                  Invoice (optional)
                                </h3>
                                <div
                                  className={`py-1.5 px-3.5 justify-between rounded-md flex border border-[#DCDEE2] ${invoiceFile?.name ? "bg-[#F2F7FF]" : "bg-[#fff]"}`}
                                >
                                  <div className="flex gap-3 items-center overflow-hidden">
                                    <Img src="/images/remit/file.svg" alt="" />
                                    <p className=" text-ellipsis truncate text-[#666666] text-sm font-normal">
                                      {invoiceFile?.name ||
                                        "Upload Canceled cheque"}
                                    </p>
                                  </div>
                                  <label
                                    htmlFor="invoice"
                                    className=" cursor-pointer text-blue-700 border border-blue-700 text-white ml-2 px-4 py-2 rounded-lg whitespace-nowrap"
                                  >
                                    {invoiceFile ? "Re-upload" : "Upload"}
                                  </label>
                                  <input
                                    {...register("invoice", {
                                      onChange: handleInvoiceFileChange,
                                    })}
                                    type="file"
                                    id="invoice"
                                    className="hidden"
                                    accept="image/*"
                                  />
                                </div>
                                {errors["invoice"] && (
                                  <p className="text-red-500 text-xs mt-1">
                                    {errors["invoice"].message as string}
                                  </p>
                                )}
                              </div>
                            </div>
                            <AlertDialogFooter className="flex justify-end items-center gap-2.5 py-5 px-10 flex-row rounded-b-lg bg-gray-button-gray-lite">
                              <AlertDialogCancel
                                className=" m-0 rounded-lg border-blue-700 border py-[11px] px-4 text-blue-700"
                                asChild
                              >
                                <button
                                  onClick={() => {
                                    reset();
                                    setInvoiceFile(null);
                                  }}
                                >
                                  Close
                                </button>
                              </AlertDialogCancel>
                              <AlertDialogAction
                                type="submit"
                                onClick={handleSubmit((data) =>
                                  handleUTR(data),
                                )}
                                className="rounded-lg border-blue-700 py-[11px] px-4 bg-blue-700 border text-white-A700"
                              >
                                Capture
                              </AlertDialogAction>
                            </AlertDialogFooter>
                          </form>
                        </AlertDialogContent>
                      </AlertDialogPortal>
                    </AlertDialog>
                  </div>
                  <DataTable
                    isToolbarVisible={false}
                    isPaginationVisible={false}
                    columnsBackground=""
                    data={UTRData}
                    columns={UTRColumn}
                  />
                </section>
              ) : (
                <section className="bg-white-A700 px-3 pb-5 rounded-xl gap-5 flex flex-col">
                  <div className="flex justify-between">
                    <div className="flex gap-5 items-center">
                      <p className="leading-4 font-semibold">Payments</p>
                      <p
                        style={{
                          backgroundColor: order_status_options.find(
                            (status) => orderdetails?.status === status.value,
                          )?.bgColor,
                          color: order_status_options.find(
                            (status) => orderdetails?.status === status.value,
                          )?.textColor,
                        }}
                        className="py-[4px] text-sm leading-4 capitalize font-medium  px-2 text-center rounded-md"
                      >
                        {!(isCaptureBtnStatus === 0 || isCaptureBtnStatus < 0)
                          ? "Pending"
                          : "Received"}
                      </p>
                    </div>
                    {challanState?.status === false ? (                      
                      <ChallanDialog
                        refechOrderdetails={OrderDetails}
                        order_id={id?.toString() as string}
                        amountDetails={{
                          fxAmount: orderdetails?.amount,
                          fxCurrency:orderdetails?.currency,
                          totalCharges: parseFloat(
                            Number(
                              Number(orderdetails?.gst) +
                                Number(orderdetails?.tcs) +
                                Number(orderdetails?.tt_charges_inclgst) +
                                Number(
                                  orderdetails?.foreign_bank_rates_inclgst,
                                ),
                            )?.toFixed(2),
                          ),
                          gstOnFx: Number(
                            orderdetails?.gst?.toFixed(2) as string,
                          ),
                          tcs: `${orderdetails?.tcs ? parseInt(orderdetails.tcs.toFixed(2)) : 0}`,
                          tt_charges: Number(
                            orderdetails?.tt_charges_inclgst?.toFixed(
                              2,
                            ) as string,
                          ),
                          foreign_bank_charges:
                            orderdetails?.foreign_bank_rates_inclgst?.toFixed(
                              2,
                            ),
                          discount: 0,
                          totalAmountPayable: parseInt(
                            orderdetails?.payable_amount.toFixed(2) as string,
                          ),
                        }}
                        setTcsEditing={setIsTCSEditing}
                        service_partner_banks={servicePartnerBanks}
                      >
                        {
                          checkLevel(LEVEL_2) ? null :
                          <button
                            onClick={() => {}}
                            disabled={
                              checkLevel(LEVEL_2)
                                ? true
                                : !(orderdetails?.doc_status === "Review"
                                    ? false
                                    : true)
                            }
                            className="rounded-lg disabled:opacity-40 py-[11px] px-4 border bg-blue-700 text-white-A700 font-semibold text-sm"
                          >
                            Generate Challan
                          </button>
                        }
                      </ChallanDialog>
                    ) : (
                      orderdetails?.status !== "cancelled" &&
                      challanState?.status === true && (
                        <div className="flex items-center gap-x-5">
                          {challanState?.status === true && (
                            <Button
                              onClick={() => {
                                window.open(
                                  challanState?.challan_url as string,
                                  "_blank",
                                );
                              }}
                              className="rounded-lg py-[11px] flex gap-2 px-4 text-[#165FE3] font-semibold text-sm"
                            >
                              Download Challan
                              <img
                                alt="upload icon"
                                src="/images/remit/uploadIcon.svg"
                                className="rotate-180"
                                style={{ height: "20px", width: "20px" }}
                              />
                            </Button>
                          )}
                          <AlertDialog
                            open={dialogOpen}
                            onOpenChange={setDialogOpen}
                          >
                            <AlertDialogTrigger className="">
                              <button
                                disabled={
                                  isCaptureBtnStatus === 0 ||
                                  isCaptureBtnStatus < 0 ||
                                  !(orderdetails?.doc_status === "Review"
                                    ? false
                                    : true)
                                }
                                className="rounded-lg py-[11px] disabled:opacity-40 px-4 border bg-blue-700 text-white-A700 font-semibold text-sm"
                              >
                                Capture Payment
                              </button>
                            </AlertDialogTrigger>
                            <AlertDialogPortal>
                              <AlertDialogOverlay className=" bg-black-900 bg-opacity-60 animate-overlayShow fixed inset-0" />
                              <AlertDialogContent className="bg-white-A700 rounded-lg p-0 max-w-md animate-contentShow">
                                <AlertDialogHeader className="flex text-left gap-4 ">
                                  <AlertDialogTitle className="font-bold border-b w-full text-xl pt-8 pb-4 px-10 leading-7 tracking-[2%] text-black-label">
                                    Add Payment Details
                                  </AlertDialogTitle>
                                </AlertDialogHeader>
                                <form className="max-w-md">
                                  <div className="flex flex-col text-left gap-4 px-10">
                                    <div className="flex gap-2 flex-shrink flex-col w-full">
                                      <label
                                        htmlFor="acknowledgement_no"
                                        className=" text-sm font-medium leading-4"
                                      >
                                        Acknowledgement Number
                                      </label>
                                      <input
                                        className="border focus:border-blue-700 p-3 rounded-lg"
                                        id="acknowledgement_no"
                                        type="number"
                                        {...register("acknowledgement_no", {
                                          required:
                                            "Acknowledgement Number is required",
                                        })}
                                        placeholder="Enter acknowledgement number"
                                      />
                                      {errors.acknowledgement_no && (
                                        <p className="text-red-500 text-xs mt-1">
                                          {
                                            errors.acknowledgement_no
                                              .message as string
                                          }
                                        </p>
                                      )}
                                    </div>
                                    <div className="flex gap-2 flex-col w-full">
                                      <label
                                        htmlFor="amount"
                                        className=" text-sm font-medium leading-4"
                                      >
                                        Amount
                                      </label>
                                      <input
                                        id="amount"
                                        type="number"
                                        className="border focus:border-blue-700 p-3 rounded-lg"
                                        {...register("amount", {
                                          required: "Amount is required",
                                          validate: (value) =>
                                            value <= isCaptureBtnStatus ||
                                            `Amount should be less than or equal to ${isCaptureBtnStatus}`,
                                        })}
                                        placeholder="Enter amount"
                                      />
                                      {errors.amount && (
                                        <p className="text-red-500 text-xs mt-1">
                                          {errors.amount.message as string}
                                        </p>
                                      )}
                                    </div>
                                    <div className="flex gap-2 flex-1 flex-grow flex-col w-full">
                                      <h3 className="text-sm font-medium leading-4">
                                        Payment Proof Document
                                      </h3>
                                      <div
                                        className={`py-1.5 px-3.5 justify-between rounded-md flex border border-[#DCDEE2] ${paymnetFile?.name ? "bg-[#F2F7FF]" : "bg-[#fff]"}`}
                                      >
                                        <div className="flex gap-3 items-center overflow-hidden">
                                          <Img
                                            src="/images/remit/file.svg"
                                            alt=""
                                          />
                                          <p className="text-ellipsis truncate">
                                            {paymnetFile?.name ||
                                              "No file selected"}
                                          </p>
                                        </div>
                                        <label
                                          htmlFor="payment-proof-document"
                                          className="cursor-pointer text-blue-700 border border-blue-700 text-white ml-2 px-4 py-2 rounded-lg whitespace-nowrap"
                                        >
                                          {paymnetFile ? "Re-upload" : "Upload"}
                                        </label>
                                        <input
                                          {...register(
                                            "payment_proof_document",
                                            {
                                              required:
                                                "Payment proof document is required",
                                              onChange:
                                                handlePaymentProofChange,
                                            },
                                          )}
                                          type="file"
                                          id="payment-proof-document"
                                          className="hidden"
                                          accept="image/*"
                                        />
                                      </div>
                                      {errors["payment_proof_document"] && (
                                        <p className="text-red-500 text-xs mt-1">
                                          {
                                            errors["payment_proof_document"]
                                              .message as string
                                          }
                                        </p>
                                      )}
                                    </div>
                                    <div className="flex gap-2 flex-1 flex-grow flex-col w-full">
                                      <h3 className=" text-sm font-medium leading-4">
                                        Supporting document (optional)
                                      </h3>
                                      <div
                                        className={`py-1.5 px-3.5 justify-between rounded-md flex border border-[#DCDEE2] ${selectedFile?.name ? "bg-[#F2F7FF]" : "bg-[#fff]"}`}
                                      >
                                        <div className="flex gap-3 items-center overflow-hidden">
                                          <Img
                                            src="/images/remit/file.svg"
                                            alt=""
                                          />
                                          <p className=" text-ellipsis truncate">
                                            {selectedFile?.name ||
                                              "No file selected"}
                                          </p>
                                        </div>
                                        <label
                                          htmlFor="supporting-document"
                                          className=" cursor-pointer text-blue-700 border border-blue-700 text-white ml-2 px-4 py-2 rounded-lg whitespace-nowrap"
                                        >
                                          {selectedFile
                                            ? "Re-upload"
                                            : "Upload"}
                                        </label>
                                        <input
                                          {...register("supporting-document", {
                                            onChange:
                                              handleSupportingFileChange,
                                          })}
                                          type="file"
                                          id="supporting-document"
                                          className="hidden"
                                          accept="image/*"
                                        />
                                      </div>
                                      {errors["supporting-document"] && (
                                        <p className="text-red-500 text-xs mt-1">
                                          {
                                            errors["supporting-document"]
                                              .message as string
                                          }
                                        </p>
                                      )}
                                    </div>
                                    <div className="text-[14px] font-400 text-[#666666] py-3">
                                      Eg: In case of name mismatch.
                                    </div>
                                  </div>
                                  <AlertDialogFooter className="flex justify-end items-center gap-2.5 py-5 px-10 flex-row rounded-b-lg bg-gray-button-gray-lite">
                                    <AlertDialogCancel
                                      className=" m-0 rounded-lg border-blue-700 border py-[11px] px-4 text-blue-700"
                                      asChild
                                    >
                                      <button
                                        onClick={() => {
                                          reset();
                                          setSelectedFile(null);
                                        }}
                                      >
                                        Close
                                      </button>
                                    </AlertDialogCancel>
                                    <AlertDialogAction
                                      type="submit"
                                      onClick={handleSubmit((data) =>
                                        onSaveClick(data, "approve"),
                                      )}
                                      className="rounded-lg border-blue-700 py-[11px] px-4 border text-blue-700"
                                    >
                                      Submit and approve
                                    </AlertDialogAction>
                                    <AlertDialogAction
                                      type="submit"
                                      onClick={handleSubmit((data) =>
                                        onSaveClick(data, ""),
                                      )}
                                      className="rounded-lg border-blue-700 py-[11px] px-4 bg-blue-700 border text-white-A700"
                                    >
                                      Capture
                                    </AlertDialogAction>
                                  </AlertDialogFooter>
                                </form>
                              </AlertDialogContent>
                            </AlertDialogPortal>
                          </AlertDialog>
                        </div>
                      )
                    )}
                  </div>
                  <div className="flex flex-col gap-4">
                    {/* Total Payable Row */}
                    <div className="flex justify-between items-center">
                      <span className="text-gray-500 text-lg">
                        Total Payable
                      </span>
                      <div className="flex items-center gap-2">
                        <span className="text-gray-500 text-sm">INR</span>
                        <span className="text-gray-800 text-lg">
                          {parseInt(orderdetails?.payable_amount?.toString())}
                        </span>
                      </div>
                    </div>

                    {/* Total Paid Row */}
                    <div className="flex justify-between items-center">
                      <span className="text-gray-500 text-lg">Total Paid</span>
                      <div className="flex items-center gap-2">
                        <span className="text-gray-500 text-sm">INR</span>
                        <span className="text-gray-800 text-lg">
                          {parseInt(
                            orderdetails?._payments_of_order.reduce(
                              (acc, item) => {
                                if (item?.status_by_AD2 === "reject") return 0;
                                return acc + item?.amount;
                              },
                              0,
                            ),
                          )}
                        </span>
                      </div>
                    </div>

                    {/* Balance Row */}
                    <div className="flex justify-between items-center bg-red-50 p-4 rounded">
                      <span className="text-red-500 text-lg">Balance</span>
                      <div className="flex items-center gap-2">
                        <span className="text-gray-500 text-sm">INR</span>
                        <span className="text-gray-800 text-lg">
                          {parseInt(isCaptureBtnStatus)}
                        </span>
                      </div>
                    </div>
                  </div>
                  <DataTable
                    isToolbarVisible={false}
                    isPaginationVisible={false}
                    columnsBackground=""
                    data={paymentData}
                    columns={columns}
                    // highlightRow={!!rowSelected}
                  />
                </section>
              )}
            </TabsContent>
            {!orderdetails?.refund_order_id && (
              <TabsContent value="other-details">
                <div className="grid grid-cols-2 gap-8 w-full">
                  <div className="w-full flex flex-col flex-grow gap-2">
                    <h5 className="text-[#999999] leading-4 font-medium text-base">
                      Remitter Details
                    </h5>
                    <div className="rounded-lg bg-[#FBFBFB] flex flex-col justify-between w-full p-2">
                      <div className="flex flex-row gap-2 items-center">
                        <h1>{orderdetails?._order_customers?.full_name}</h1>
                      </div>
                      <div className="flex text-gray-400 items-center gap-2">
                        <h1>Email:</h1>
                        <span className={valueStyle} style={{ color: "gray" }}>
                          {orderdetails?._order_customers?.email}
                        </span>
                      </div>
                      <div className="flex text-gray-400 items-center gap-2">
                        <h1>Mobile:</h1>
                        <span className={valueStyle} style={{ color: "gray" }}>
                          {orderdetails?._order_customers?.phone_number
                            ? orderdetails?._order_customers?.phone_number
                            : " N/A"}
                        </span>
                      </div>
                    </div>
                  </div>
                  {studentName?.value && (
                    <div className="w-full flex flex-col flex-grow gap-2">
                      <h5 className="text-[#999999] leading-4 font-medium text-base">
                        Student details
                      </h5>
                      <div className="flex gap-5 p-5 flex-col rounded-xl border border-white-A700 shadow-[1px_1px_7px_0px_rgba(34,82,167,0.1)]">
                        <div className="rounded-lg bg-[#FBFBFB] flex flex-col justify-between w-full">
                          <div className="flex text-gray-400 item-center gap-2">
                            <h1 className="font-medium text-base leading-[25.6px] text-black-label">
                              {studentName?.value || "N/A"}
                            </h1>
                          </div>
                          <div className="flex text-gray-400 item-center gap-2">
                            <h1>Passport:</h1>
                            <span
                              className={valueStyle}
                              style={{ color: "gray" }}
                            >
                              {orderdetails?._order_service_partner
                                .passport_no || "N/A"}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                <div className="w-full flex flex-col flex-grow gap-5 my-8">
                  <h5 className="text-[#999999] leading-4 font-medium text-base">
                    Beneficiary details
                  </h5>
                  <div className="flex gap-4 p-5 flex-col rounded-xl bg-[#FBFBFB]">
                    <div className="rounded-lg  flex flex-col justify-between w-full gap-3">
                      <div className="flex flex-row gap-2 items-center">
                        <h1 className="font-medium text-base leading-[25.6px] text-black-label">
                          {orderdetails?._beneficiary?.name || "N/A"}
                        </h1>
                      </div>
                      <div className="flex text-gray-400 item-center gap-4">
                        <h1>Bank name:</h1>
                        <span className={valueStyle}>
                          {orderdetails?._beneficiary?.bank_name}
                        </span>
                      </div>
                      <div className="flex text-gray-400 item-center gap-4">
                        <h1>Account number / IBAN:</h1>
                        {(orderdetails?._beneficiary?.account_number ||
                          orderdetails?._beneficiary?.iban_no) && (
                          <span className={valueStyle}>
                            {orderdetails?._beneficiary?.account_number ||
                              orderdetails?._beneficiary?.iban_no}
                          </span>
                        )}
                      </div>
                      <div className="flex text-gray-400 item-center gap-4">
                        <h1>SWIFT Code:</h1>
                        <span className={valueStyle}>
                          {orderdetails?._beneficiary?.swift_code || "N/A"}
                        </span>
                      </div>
                      <div className="flex text-gray-400 item-center gap-4">
                        <h1>Reference number:</h1>
                        <span className={valueStyle}>
                          {orderdetails?.reference_no || "N/A"}
                        </span>
                      </div>
                      {/* <div className="flex text-gray-400 item-center gap-4">
                      <h1>Correspondent bank name :</h1>
                      <span className={valueStyle}>
                        {orderdetails?._beneficiary?.correspondant_bank_name ||
                          "N/A"}
                      </span>
                    </div>
                    <div className="flex text-gray-400 item-center gap-4">
                      <h1>Correspondent bank number :</h1>
                      <span className={valueStyle}>
                        {orderdetails?._beneficiary?.correspondant_bank_no ||
                          "N/A"}
                      </span>
                    </div> */}
                      <div className="flex text-gray-400 item-center gap-4">
                        <h1>Bank Address:</h1>
                        <span className={valueStyle}>
                          {orderdetails?._beneficiary?.bank_addr || "N/A"}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* partner details */}
                {channelDetails?.id === 12 && !checkLevel(LEVEL_2) && (
                  <div className="w-full flex flex-col flex-grow gap-5 my-8">
                    <h5 className="text-[#999999] leading-4 font-medium text-base">
                      Partner Details
                    </h5>
                    <div className="flex gap-5 p-5 bg-[#FBFBFB] flex-col rounded-xl border border-white-A700">
                      <div className="rounded-lg flex flex-col justify-between w-full gap-3">
                        <div className="flex flex-row gap-2 items-center">
                          <span
                            className="bg-[#EFF4FF] text-black-200 rounded-lg p-2"
                            style={{ fontWeight: "400" }}
                          >
                            {orderdetails?.partner_detail?.type.toUpperCase()}
                          </span>
                          <h1 className="font-medium text-base leading-[25.6px] text-black-label">
                            {orderdetails?.partner_detail?.name || "N/A"}
                          </h1>
                        </div>
                        <div className="flex gap-2">
                          <p className={labelStyle}>
                            Partner Trade:{" "}
                            <span className={valueStyle}>
                              {orderdetails?.partner_detail?.type || "N/A"}
                            </span>
                          </p>
                        </div>
                        <div className="flex gap-2">
                          <p className={labelStyle}>
                            Branch Location:{" "}
                            <span className={valueStyle}>
                              {orderdetails?.partner_detail?.city || "N/A"},{" "}
                              {orderdetails?.partner_detail?.state || "N/A"}
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* Service provider details */}
                {!checkLevel(LEVEL_2) && (
                  <div className="w-full flex flex-col flex-grow gap-5 my-8">
                    <h5 className="text-[#999999] leading-4 font-medium text-base">
                      Service provider details
                    </h5>
                    <div className="flex gap-5 p-5 bg-[#FBFBFB] flex-col rounded-xl border border-white-A700">
                      <div className="rounded-lg flex flex-col justify-between w-full gap-3">
                        <div className="flex flex-row gap-2 items-center">
                          <h1 className="font-medium text-base leading-[25.6px] text-black-label">
                            {orderdetails?._order_service_partner?.display_name}
                          </h1>
                        </div>
                        <div className="flex gap-2">
                          <p className={labelStyle}>
                            Email:{" "}
                            <span className={valueStyle}>
                              {orderdetails?._order_service_partner?.email}
                            </span>
                          </p>
                        </div>
                        <div className="flex gap-2">
                          <p className={labelStyle}>
                            Service ID:{" "}
                            <span className={valueStyle}>
                              {orderdetails?._order_service_partner?.id}
                            </span>
                          </p>
                        </div>
                        <div className="flex gap-2">
                          <p className={labelStyle}>
                            Location:{" "}
                            <span className={valueStyle}>
                              {orderdetails?._order_service_partner
                                ?.legal_addr_city &&
                              orderdetails?._order_service_partner
                                ?.legal_addr_state
                                ? `${orderdetails?._order_service_partner?.legal_addr_city}, ${orderdetails?._order_service_partner?.legal_addr_state}`
                                : orderdetails?._order_service_partner
                                    ?.legal_addr_city ||
                                  orderdetails?._order_service_partner
                                    ?.legal_addr_state ||
                                  "N/A"}
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* <div className="w-full flex flex-col flex-grow gap-2"> */}
                {/* <h5>Partner Details</h5> */}
                {/* <div className="flex gap-5 p-5 flex-col rounded-xl border border-white-A700 shadow-[1px_1px_7px_0px_rgba(34,82,167,0.1)]"> */}
                {/* <div className="rounded-lg flex justify-between w-full">
                    <div className="flex gap-2">
                      <p className={labelStyle}>
                        Name: <span className={valueStyle}></span>
                      </p>
                    </div>
                    <div className="flex gap-2">
                      <p className={labelStyle}>
                        Parner ID: <span className={valueStyle}></span>
                      </p>
                    </div>
                  </div> */}

                <div className="rounded-lg p-2 bg-[#FFEAC9] w-[450px]">
                  <h1 className="text-[#000]">
                    This order has been created from Lead ID{" "}
                    <a
                      // href={`/remit/leads?dealid=${orderdetails?.opportunity_id}`}
                      onClick={handleLeadRedirect}
                      className="text-blue-600 underline cursor-pointer"
                    >
                      ID - {orderdetails?.opportunity_id}
                    </a>
                  </h1>
                </div>
                {/* <div className="rounded-lg flex justify-between w-full">
                    <div className="flex gap-2">
                      <p className={labelStyle}></p>
                    </div>
                    <div className="flex gap-2">
                      <p className={labelStyle}></p>
                    </div>
                  </div> */}
                {/* </div> */}
                {/* </div> */}
              </TabsContent>
            )}
          </Tabs>
        </div>
        <section className=" rounded-xl bg-white-A700 border p-3 w-[20%] h-full">
          <MilestoneTracker milestones={orderdetails?.order_mileston || []} />
        </section>
      </div>
      <Toaster position="top-right" />
    </>
  );
};

export default NewOrderDetailsPage;

const TCSWarning = ({
  children,
  handleSubmit,
  order_id,
  tcsValue,
  tcs_amount,
}: {
  children: React.ReactNode;
  handleSubmit: (order_id: number, notes: string, tcs_amount: number) => void;
  order_id: string;
  tcsValue: string;
  tcs_amount: string;
}) => {
  return (
    <AlertDialog>
      <AlertDialogTrigger>{children}</AlertDialogTrigger>
      <AlertDialogPortal>
        <AlertDialogOverlay className=" bg-black-900 bg-opacity-60 animate-overlayShow fixed inset-0" />
        <AlertDialogContent className="bg-white-A700 rounded-lg p-0 max-w-2xl animate-contentShow">
          <AlertDialogHeader className="flex text-left gap-4 pt-8 pb-4 px-10 ">
            <AlertDialogTitle className="font-bold text-xl text-red-500 leading-7 tracking-[2%]">
              Warning
            </AlertDialogTitle>
            <AlertDialogDescription className="font-medium text-base -tracking-[3%] text-black-900 leading-[150%]  ">
              TCS of Rs {tcs_amount} was calculated by the system which is
              greater than {tcsValue}
              <p className="pt-6">Do you still want to continue?</p>
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter className="flex justify-end items-center gap-2.5 py-5 px-10 flex-row rounded-b-lg bg-gray-button-gray-lite">
            <AlertDialogCancel className=" m-0 rounded-lg border-blue-700 border py-[11px] px-4 text-blue-700">
              Cancel
            </AlertDialogCancel>
            <AlertDialogAction
              className="rounded-lg border-blue-700 py-[11px] px-4 bg-blue-700 border text-white-A700"
              onClick={() => {
                handleSubmit(
                  parseInt(order_id),
                  "TCS amount is greater than AD updated amount",
                  parseInt(tcsValue),
                );
              }}
            >
              Continue
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogPortal>
    </AlertDialog>
  );
};
